// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/img/Background_Default_1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/img/Background_Special.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/img/badges/astronaut.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/img/badges/background.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/img/badges/more_badges.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/img/exam-result/banner.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/public/img/exam-result/boy-figure.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/public/img/exam-result/bubble.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/public/img/exam-result/jc-banner.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/src/assets/background/Background_Default_1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("@assets/images/mock_exam_poster.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("@assets/images/webinar_poster.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pointer-events-none {
        pointer-events: none;
}
.visible {
        visibility: visible;
}
.invisible {
        visibility: hidden;
}
.static {
        position: static;
}
.fixed {
        position: fixed;
}
.absolute {
        position: absolute;
}
.relative {
        position: relative;
}
.sticky {
        position: sticky;
}
.\\!top-\\[3\\.1rem\\] {
        top: 3.1rem !important;
}
.-bottom-\\[12px\\] {
        bottom: -12px;
}
.-left-4 {
        left: -1rem;
}
.-left-\\[18px\\] {
        left: -18px;
}
.-right-\\[138px\\] {
        right: -138px;
}
.-right-\\[4px\\] {
        right: -4px;
}
.-right-\\[50px\\] {
        right: -50px;
}
.-right-\\[83px\\] {
        right: -83px;
}
.-top-0 {
        top: -0px;
}
.-top-0\\.5 {
        top: -0.125rem;
}
.-top-\\[4px\\] {
        top: -4px;
}
.-top-\\[5px\\] {
        top: -5px;
}
.bottom-0 {
        bottom: 0px;
}
.bottom-1 {
        bottom: 0.25rem;
}
.bottom-8 {
        bottom: 2rem;
}
.bottom-\\[-34px\\] {
        bottom: -34px;
}
.bottom-\\[24px\\] {
        bottom: 24px;
}
.bottom-\\[80px\\] {
        bottom: 80px;
}
.left-0 {
        left: 0px;
}
.left-1\\/2 {
        left: 50%;
}
.left-4 {
        left: 1rem;
}
.left-6 {
        left: 1.5rem;
}
.left-\\[0px\\] {
        left: 0px;
}
.left-\\[10px\\] {
        left: 10px;
}
.left-\\[17px\\] {
        left: 17px;
}
.left-\\[20px\\] {
        left: 20px;
}
.right-0 {
        right: 0px;
}
.right-2 {
        right: 0.5rem;
}
.right-2\\.5 {
        right: 0.625rem;
}
.right-4 {
        right: 1rem;
}
.right-6 {
        right: 1.5rem;
}
.right-\\[-140px\\] {
        right: -140px;
}
.right-\\[-20px\\] {
        right: -20px;
}
.right-\\[-220px\\] {
        right: -220px;
}
.right-\\[-8px\\] {
        right: -8px;
}
.right-\\[150px\\] {
        right: 150px;
}
.right-\\[30px\\] {
        right: 30px;
}
.right-\\[33px\\] {
        right: 33px;
}
.right-\\[36px\\] {
        right: 36px;
}
.right-\\[38px\\] {
        right: 38px;
}
.top-0 {
        top: 0px;
}
.top-1\\/2 {
        top: 50%;
}
.top-1\\/3 {
        top: 33.333333%;
}
.top-10 {
        top: 2.5rem;
}
.top-11 {
        top: 2.75rem;
}
.top-2 {
        top: 0.5rem;
}
.top-3 {
        top: 0.75rem;
}
.top-6 {
        top: 1.5rem;
}
.top-8 {
        top: 2rem;
}
.top-\\[-25px\\] {
        top: -25px;
}
.top-\\[10px\\] {
        top: 10px;
}
.top-\\[20vh\\] {
        top: 20vh;
}
.top-\\[30px\\] {
        top: 30px;
}
.top-\\[35px\\] {
        top: 35px;
}
.top-\\[36px\\] {
        top: 36px;
}
.top-\\[40px\\] {
        top: 40px;
}
.top-\\[46px\\] {
        top: 46px;
}
.top-\\[4px\\] {
        top: 4px;
}
.top-\\[50vh\\] {
        top: 50vh;
}
.top-\\[55px\\] {
        top: 55px;
}
.top-\\[60px\\] {
        top: 60px;
}
.top-\\[65px\\] {
        top: 65px;
}
.top-\\[70px\\] {
        top: 70px;
}
.top-\\[72px\\] {
        top: 72px;
}
.top-\\[80px\\] {
        top: 80px;
}
.top-\\[84px\\] {
        top: 84px;
}
.top-\\[8px\\] {
        top: 8px;
}
.top-\\[9px\\] {
        top: 9px;
}
.isolate {
        isolation: isolate;
}
.\\!z-\\[101\\] {
        z-index: 101 !important;
}
.-z-10 {
        z-index: -10;
}
.z-0 {
        z-index: 0;
}
.z-10 {
        z-index: 10;
}
.z-100 {
        z-index: 100;
}
.z-20 {
        z-index: 20;
}
.z-30 {
        z-index: 30;
}
.z-\\[1000\\] {
        z-index: 1000;
}
.z-\\[101\\] {
        z-index: 101;
}
.z-\\[18\\] {
        z-index: 18;
}
.z-\\[19\\] {
        z-index: 19;
}
.z-\\[1\\] {
        z-index: 1;
}
.z-\\[2\\] {
        z-index: 2;
}
.z-\\[999\\] {
        z-index: 999;
}
.z-\\[99\\] {
        z-index: 99;
}
.float-right {
        float: right;
}
.float-left {
        float: left;
}
.clear-both {
        clear: both;
}
.m-auto {
        margin: auto;
}
.-mx-4 {
        margin-left: -1rem;
        margin-right: -1rem;
}
.-mx-5 {
        margin-left: -1.25rem;
        margin-right: -1.25rem;
}
.-mx-6 {
        margin-left: -1.5rem;
        margin-right: -1.5rem;
}
.-my-4 {
        margin-top: -1rem;
        margin-bottom: -1rem;
}
.mx-3 {
        margin-left: 0.75rem;
        margin-right: 0.75rem;
}
.mx-6 {
        margin-left: 1.5rem;
        margin-right: 1.5rem;
}
.mx-\\[0px\\] {
        margin-left: 0px;
        margin-right: 0px;
}
.mx-auto {
        margin-left: auto;
        margin-right: auto;
}
.my-10 {
        margin-top: 2.5rem;
        margin-bottom: 2.5rem;
}
.my-2 {
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
}
.my-3 {
        margin-top: 0.75rem;
        margin-bottom: 0.75rem;
}
.my-\\[31px\\] {
        margin-top: 31px;
        margin-bottom: 31px;
}
.my-auto {
        margin-top: auto;
        margin-bottom: auto;
}
.\\!ml-0 {
        margin-left: 0px !important;
}
.\\!mt-2 {
        margin-top: 0.5rem !important;
}
.-mb-3 {
        margin-bottom: -0.75rem;
}
.-mb-4 {
        margin-bottom: -1rem;
}
.-mb-\\[10px\\] {
        margin-bottom: -10px;
}
.-mb-\\[9px\\] {
        margin-bottom: -9px;
}
.-ml-2 {
        margin-left: -0.5rem;
}
.-ml-4 {
        margin-left: -1rem;
}
.-mr-4 {
        margin-right: -1rem;
}
.-mt-6 {
        margin-top: -1.5rem;
}
.-mt-\\[21px\\] {
        margin-top: -21px;
}
.mb-0 {
        margin-bottom: 0px;
}
.mb-0\\.5 {
        margin-bottom: 0.125rem;
}
.mb-1 {
        margin-bottom: 0.25rem;
}
.mb-10 {
        margin-bottom: 2.5rem;
}
.mb-2 {
        margin-bottom: 0.5rem;
}
.mb-3 {
        margin-bottom: 0.75rem;
}
.mb-3\\.5 {
        margin-bottom: 0.875rem;
}
.mb-4 {
        margin-bottom: 1rem;
}
.mb-5 {
        margin-bottom: 1.25rem;
}
.mb-6 {
        margin-bottom: 1.5rem;
}
.mb-7 {
        margin-bottom: 1.75rem;
}
.mb-8 {
        margin-bottom: 2rem;
}
.mb-\\[16px\\] {
        margin-bottom: 16px;
}
.mb-\\[17px\\] {
        margin-bottom: 17px;
}
.mb-\\[19px\\] {
        margin-bottom: 19px;
}
.mb-\\[20px\\] {
        margin-bottom: 20px;
}
.mb-\\[24px\\] {
        margin-bottom: 24px;
}
.mb-\\[26px\\] {
        margin-bottom: 26px;
}
.mb-\\[30px\\] {
        margin-bottom: 30px;
}
.mb-\\[32px\\] {
        margin-bottom: 32px;
}
.mb-\\[33px\\] {
        margin-bottom: 33px;
}
.mb-\\[6px\\] {
        margin-bottom: 6px;
}
.ml-1 {
        margin-left: 0.25rem;
}
.ml-10 {
        margin-left: 2.5rem;
}
.ml-2 {
        margin-left: 0.5rem;
}
.ml-3 {
        margin-left: 0.75rem;
}
.ml-4 {
        margin-left: 1rem;
}
.ml-6 {
        margin-left: 1.5rem;
}
.ml-\\[-30px\\] {
        margin-left: -30px;
}
.ml-\\[12px\\] {
        margin-left: 12px;
}
.ml-\\[16px\\] {
        margin-left: 16px;
}
.ml-\\[24px\\] {
        margin-left: 24px;
}
.ml-auto {
        margin-left: auto;
}
.mr-0 {
        margin-right: 0px;
}
.mr-0\\.5 {
        margin-right: 0.125rem;
}
.mr-1 {
        margin-right: 0.25rem;
}
.mr-1\\.5 {
        margin-right: 0.375rem;
}
.mr-2 {
        margin-right: 0.5rem;
}
.mr-3 {
        margin-right: 0.75rem;
}
.mr-4 {
        margin-right: 1rem;
}
.mr-6 {
        margin-right: 1.5rem;
}
.mr-8 {
        margin-right: 2rem;
}
.mr-\\[24px\\] {
        margin-right: 24px;
}
.mr-\\[2px\\] {
        margin-right: 2px;
}
.mr-\\[30px\\] {
        margin-right: 30px;
}
.mr-\\[4px\\] {
        margin-right: 4px;
}
.mr-auto {
        margin-right: auto;
}
.mt-1 {
        margin-top: 0.25rem;
}
.mt-10 {
        margin-top: 2.5rem;
}
.mt-12 {
        margin-top: 3rem;
}
.mt-2 {
        margin-top: 0.5rem;
}
.mt-3 {
        margin-top: 0.75rem;
}
.mt-4 {
        margin-top: 1rem;
}
.mt-5 {
        margin-top: 1.25rem;
}
.mt-6 {
        margin-top: 1.5rem;
}
.mt-7 {
        margin-top: 1.75rem;
}
.mt-8 {
        margin-top: 2rem;
}
.mt-\\[-15px\\] {
        margin-top: -15px;
}
.mt-\\[-16px\\] {
        margin-top: -16px;
}
.mt-\\[-18px\\] {
        margin-top: -18px;
}
.mt-\\[-23px\\] {
        margin-top: -23px;
}
.mt-\\[-2px\\] {
        margin-top: -2px;
}
.mt-\\[-30px\\] {
        margin-top: -30px;
}
.mt-\\[-35px\\] {
        margin-top: -35px;
}
.mt-\\[-3px\\] {
        margin-top: -3px;
}
.mt-\\[-5px\\] {
        margin-top: -5px;
}
.mt-\\[-8px\\] {
        margin-top: -8px;
}
.mt-\\[10px\\] {
        margin-top: 10px;
}
.mt-\\[12px\\] {
        margin-top: 12px;
}
.mt-\\[16px\\] {
        margin-top: 16px;
}
.mt-\\[20px\\] {
        margin-top: 20px;
}
.mt-\\[21px\\] {
        margin-top: 21px;
}
.mt-\\[24px\\] {
        margin-top: 24px;
}
.mt-\\[2px\\] {
        margin-top: 2px;
}
.mt-\\[40px\\] {
        margin-top: 40px;
}
.mt-\\[4px\\] {
        margin-top: 4px;
}
.mt-\\[5px\\] {
        margin-top: 5px;
}
.mt-auto {
        margin-top: auto;
}
.line-clamp-2 {
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
}
.\\!block {
        display: block !important;
}
.block {
        display: block;
}
.inline-block {
        display: inline-block;
}
.inline {
        display: inline;
}
.\\!flex {
        display: flex !important;
}
.flex {
        display: flex;
}
.inline-flex {
        display: inline-flex;
}
.table {
        display: table;
}
.grid {
        display: grid;
}
.list-item {
        display: list-item;
}
.hidden {
        display: none;
}
.\\!h-9 {
        height: 2.25rem !important;
}
.\\!h-\\[30px\\] {
        height: 30px !important;
}
.\\!h-\\[34px\\] {
        height: 34px !important;
}
.\\!h-\\[38px\\] {
        height: 38px !important;
}
.\\!h-\\[56px\\] {
        height: 56px !important;
}
.\\!h-\\[calc\\(100vh-68px\\)\\] {
        height: calc(100vh - 68px) !important;
}
.\\!h-auto {
        height: auto !important;
}
.\\!h-fit {
        height: -moz-fit-content !important;
        height: fit-content !important;
}
.h-0 {
        height: 0px;
}
.h-1 {
        height: 0.25rem;
}
.h-10 {
        height: 2.5rem;
}
.h-12 {
        height: 3rem;
}
.h-2 {
        height: 0.5rem;
}
.h-2\\.5 {
        height: 0.625rem;
}
.h-3 {
        height: 0.75rem;
}
.h-3\\.5 {
        height: 0.875rem;
}
.h-4 {
        height: 1rem;
}
.h-5 {
        height: 1.25rem;
}
.h-6 {
        height: 1.5rem;
}
.h-8 {
        height: 2rem;
}
.h-\\[100\\%\\] {
        height: 100%;
}
.h-\\[102px\\] {
        height: 102px;
}
.h-\\[108px\\] {
        height: 108px;
}
.h-\\[11px\\] {
        height: 11px;
}
.h-\\[120px\\] {
        height: 120px;
}
.h-\\[125px\\] {
        height: 125px;
}
.h-\\[130px\\] {
        height: 130px;
}
.h-\\[14px\\] {
        height: 14px;
}
.h-\\[150px\\] {
        height: 150px;
}
.h-\\[157px\\] {
        height: 157px;
}
.h-\\[16px\\] {
        height: 16px;
}
.h-\\[1px\\] {
        height: 1px;
}
.h-\\[20px\\] {
        height: 20px;
}
.h-\\[213px\\] {
        height: 213px;
}
.h-\\[246px\\] {
        height: 246px;
}
.h-\\[24px\\] {
        height: 24px;
}
.h-\\[250px\\] {
        height: 250px;
}
.h-\\[274px\\] {
        height: 274px;
}
.h-\\[28px\\] {
        height: 28px;
}
.h-\\[294px\\] {
        height: 294px;
}
.h-\\[313px\\] {
        height: 313px;
}
.h-\\[350px\\] {
        height: 350px;
}
.h-\\[35px\\] {
        height: 35px;
}
.h-\\[37px\\] {
        height: 37px;
}
.h-\\[388px\\] {
        height: 388px;
}
.h-\\[45px\\] {
        height: 45px;
}
.h-\\[498px\\] {
        height: 498px;
}
.h-\\[525px\\] {
        height: 525px;
}
.h-\\[60px\\] {
        height: 60px;
}
.h-\\[64px\\] {
        height: 64px;
}
.h-\\[68px\\] {
        height: 68px;
}
.h-\\[70px\\] {
        height: 70px;
}
.h-\\[710px\\] {
        height: 710px;
}
.h-\\[72px\\] {
        height: 72px;
}
.h-\\[78px\\] {
        height: 78px;
}
.h-\\[80px\\] {
        height: 80px;
}
.h-\\[86px\\] {
        height: 86px;
}
.h-\\[88px\\] {
        height: 88px;
}
.h-\\[90px\\] {
        height: 90px;
}
.h-\\[928px\\] {
        height: 928px;
}
.h-\\[95\\%\\] {
        height: 95%;
}
.h-\\[96px\\] {
        height: 96px;
}
.h-\\[calc\\(\\(100\\*var\\(--vh\\2c vh\\)\\)-64px\\)\\] {
        height: calc((100 * var(--vh,vh)) - 64px);
}
.h-\\[calc\\(100\\%-28px\\)\\] {
        height: calc(100% - 28px);
}
.h-\\[calc\\(100\\%-64px\\)\\] {
        height: calc(100% - 64px);
}
.h-\\[calc\\(100svh-68px\\)\\] {
        height: calc(100svh - 68px);
}
.h-\\[calc\\(100vh-300px\\)\\] {
        height: calc(100vh - 300px);
}
.h-\\[calc\\(100vh-400px\\)\\] {
        height: calc(100vh - 400px);
}
.h-\\[calc\\(100vh-500px\\)\\] {
        height: calc(100vh - 500px);
}
.h-\\[calc\\(100vh-68px\\)\\] {
        height: calc(100vh - 68px);
}
.h-fit {
        height: -moz-fit-content;
        height: fit-content;
}
.h-full {
        height: 100%;
}
.h-screen {
        height: 100vh;
}
.max-h-5 {
        max-height: 1.25rem;
}
.max-h-\\[200px\\] {
        max-height: 200px;
}
.max-h-\\[27px\\] {
        max-height: 27px;
}
.max-h-\\[348px\\] {
        max-height: 348px;
}
.max-h-\\[365px\\] {
        max-height: 365px;
}
.max-h-\\[80vh\\] {
        max-height: 80vh;
}
.max-h-\\[calc\\(100\\%-50px\\)\\] {
        max-height: calc(100% - 50px);
}
.max-h-\\[calc\\(100vh-100px\\)\\] {
        max-height: calc(100vh - 100px);
}
.max-h-\\[calc\\(100vh-116px\\)\\] {
        max-height: calc(100vh - 116px);
}
.max-h-full {
        max-height: 100%;
}
.min-h-\\[150px\\] {
        min-height: 150px;
}
.min-h-\\[24px\\] {
        min-height: 24px;
}
.min-h-\\[250px\\] {
        min-height: 250px;
}
.min-h-\\[700px\\] {
        min-height: 700px;
}
.min-h-\\[96px\\] {
        min-height: 96px;
}
.min-h-full {
        min-height: 100%;
}
.min-h-screen {
        min-height: 100vh;
}
.\\!w-\\[124px\\] {
        width: 124px !important;
}
.\\!w-\\[14px\\] {
        width: 14px !important;
}
.\\!w-\\[calc\\(100\\%-16px\\)\\] {
        width: calc(100% - 16px) !important;
}
.\\!w-full {
        width: 100% !important;
}
.w-1 {
        width: 0.25rem;
}
.w-1\\/2 {
        width: 50%;
}
.w-1\\/3 {
        width: 33.333333%;
}
.w-1\\/6 {
        width: 16.666667%;
}
.w-10 {
        width: 2.5rem;
}
.w-10\\/12 {
        width: 83.333333%;
}
.w-11\\/12 {
        width: 91.666667%;
}
.w-2 {
        width: 0.5rem;
}
.w-2\\.5 {
        width: 0.625rem;
}
.w-2\\/12 {
        width: 16.666667%;
}
.w-20 {
        width: 5rem;
}
.w-24 {
        width: 6rem;
}
.w-3 {
        width: 0.75rem;
}
.w-3\\.5 {
        width: 0.875rem;
}
.w-32 {
        width: 8rem;
}
.w-4 {
        width: 1rem;
}
.w-5 {
        width: 1.25rem;
}
.w-5\\/12 {
        width: 41.666667%;
}
.w-5\\/6 {
        width: 83.333333%;
}
.w-56 {
        width: 14rem;
}
.w-6 {
        width: 1.5rem;
}
.w-7 {
        width: 1.75rem;
}
.w-8 {
        width: 2rem;
}
.w-8\\/12 {
        width: 66.666667%;
}
.w-\\[10\\%\\] {
        width: 10%;
}
.w-\\[10px\\] {
        width: 10px;
}
.w-\\[110px\\] {
        width: 110px;
}
.w-\\[11px\\] {
        width: 11px;
}
.w-\\[12\\%\\] {
        width: 12%;
}
.w-\\[120px\\] {
        width: 120px;
}
.w-\\[122px\\] {
        width: 122px;
}
.w-\\[126px\\] {
        width: 126px;
}
.w-\\[127px\\] {
        width: 127px;
}
.w-\\[136px\\] {
        width: 136px;
}
.w-\\[14px\\] {
        width: 14px;
}
.w-\\[15\\%\\] {
        width: 15%;
}
.w-\\[150px\\] {
        width: 150px;
}
.w-\\[155px\\] {
        width: 155px;
}
.w-\\[165px\\] {
        width: 165px;
}
.w-\\[16px\\] {
        width: 16px;
}
.w-\\[187px\\] {
        width: 187px;
}
.w-\\[18px\\] {
        width: 18px;
}
.w-\\[20\\%\\] {
        width: 20%;
}
.w-\\[20px\\] {
        width: 20px;
}
.w-\\[21\\] {
        width: 21;
}
.w-\\[240px\\] {
        width: 240px;
}
.w-\\[250px\\] {
        width: 250px;
}
.w-\\[254px\\] {
        width: 254px;
}
.w-\\[258px\\] {
        width: 258px;
}
.w-\\[262px\\] {
        width: 262px;
}
.w-\\[275px\\] {
        width: 275px;
}
.w-\\[276px\\] {
        width: 276px;
}
.w-\\[28px\\] {
        width: 28px;
}
.w-\\[3\\%\\] {
        width: 3%;
}
.w-\\[30\\%\\] {
        width: 30%;
}
.w-\\[315px\\] {
        width: 315px;
}
.w-\\[320px\\] {
        width: 320px;
}
.w-\\[326px\\] {
        width: 326px;
}
.w-\\[33\\%\\] {
        width: 33%;
}
.w-\\[340px\\] {
        width: 340px;
}
.w-\\[355px\\] {
        width: 355px;
}
.w-\\[372px\\] {
        width: 372px;
}
.w-\\[378px\\] {
        width: 378px;
}
.w-\\[37px\\] {
        width: 37px;
}
.w-\\[38px\\] {
        width: 38px;
}
.w-\\[405px\\] {
        width: 405px;
}
.w-\\[456px\\] {
        width: 456px;
}
.w-\\[469px\\] {
        width: 469px;
}
.w-\\[47\\%\\] {
        width: 47%;
}
.w-\\[5\\%\\] {
        width: 5%;
}
.w-\\[50\\%\\] {
        width: 50%;
}
.w-\\[52px\\] {
        width: 52px;
}
.w-\\[6\\%\\] {
        width: 6%;
}
.w-\\[60px\\] {
        width: 60px;
}
.w-\\[65\\%\\] {
        width: 65%;
}
.w-\\[70\\%\\] {
        width: 70%;
}
.w-\\[70vh\\] {
        width: 70vh;
}
.w-\\[76px\\] {
        width: 76px;
}
.w-\\[8\\%\\] {
        width: 8%;
}
.w-\\[80px\\] {
        width: 80px;
}
.w-\\[88px\\] {
        width: 88px;
}
.w-\\[90\\%\\] {
        width: 90%;
}
.w-\\[928px\\] {
        width: 928px;
}
.w-\\[95\\%\\] {
        width: 95%;
}
.w-\\[96px\\] {
        width: 96px;
}
.w-\\[calc\\(100\\%\\*512\\/1099\\)\\] {
        width: calc(100% * 512 / 1099);
}
.w-\\[calc\\(100\\%\\*560\\/1099\\)\\] {
        width: calc(100% * 560 / 1099);
}
.w-auto {
        width: auto;
}
.w-fit {
        width: -moz-fit-content;
        width: fit-content;
}
.w-full {
        width: 100%;
}
.w-max {
        width: -moz-max-content;
        width: max-content;
}
.w-screen {
        width: 100vw;
}
.min-w-0 {
        min-width: 0px;
}
.min-w-\\[14px\\] {
        min-width: 14px;
}
.min-w-\\[32px\\] {
        min-width: 32px;
}
.min-w-\\[44px\\] {
        min-width: 44px;
}
.min-w-\\[530px\\] {
        min-width: 530px;
}
.min-w-\\[60px\\] {
        min-width: 60px;
}
.min-w-\\[80px\\] {
        min-width: 80px;
}
.min-w-\\[96px\\] {
        min-width: 96px;
}
.min-w-full {
        min-width: 100%;
}
.\\!max-w-\\[100\\%\\] {
        max-width: 100% !important;
}
.\\!max-w-\\[240px\\] {
        max-width: 240px !important;
}
.\\!max-w-\\[300px\\] {
        max-width: 300px !important;
}
.\\!max-w-\\[450px\\] {
        max-width: 450px !important;
}
.\\!max-w-\\[460px\\] {
        max-width: 460px !important;
}
.\\!max-w-\\[462px\\] {
        max-width: 462px !important;
}
.\\!max-w-\\[463px\\] {
        max-width: 463px !important;
}
.\\!max-w-\\[512px\\] {
        max-width: 512px !important;
}
.\\!max-w-\\[560px\\] {
        max-width: 560px !important;
}
.\\!max-w-\\[calc\\(100\\%-2px\\)\\] {
        max-width: calc(100% - 2px) !important;
}
.\\!max-w-\\[calc\\(100\\%-32px\\)\\] {
        max-width: calc(100% - 32px) !important;
}
.\\!max-w-full {
        max-width: 100% !important;
}
.\\!max-w-none {
        max-width: none !important;
}
.max-w-\\[100\\%\\] {
        max-width: 100%;
}
.max-w-\\[126px\\] {
        max-width: 126px;
}
.max-w-\\[1366px\\] {
        max-width: 1366px;
}
.max-w-\\[200px\\] {
        max-width: 200px;
}
.max-w-\\[20px\\] {
        max-width: 20px;
}
.max-w-\\[250px\\] {
        max-width: 250px;
}
.max-w-\\[280px\\] {
        max-width: 280px;
}
.max-w-\\[300px\\] {
        max-width: 300px;
}
.max-w-\\[336px\\] {
        max-width: 336px;
}
.max-w-\\[340px\\] {
        max-width: 340px;
}
.max-w-\\[343px\\] {
        max-width: 343px;
}
.max-w-\\[352px\\] {
        max-width: 352px;
}
.max-w-\\[363px\\] {
        max-width: 363px;
}
.max-w-\\[378px\\] {
        max-width: 378px;
}
.max-w-\\[400px\\] {
        max-width: 400px;
}
.max-w-\\[40px\\] {
        max-width: 40px;
}
.max-w-\\[450px\\] {
        max-width: 450px;
}
.max-w-\\[675px\\] {
        max-width: 675px;
}
.max-w-\\[80\\%\\] {
        max-width: 80%;
}
.max-w-\\[90\\%\\] {
        max-width: 90%;
}
.max-w-\\[calc\\(100\\%-10px\\)\\] {
        max-width: calc(100% - 10px);
}
.max-w-\\[unset\\] {
        max-width: unset;
}
.max-w-fit {
        max-width: -moz-fit-content;
        max-width: fit-content;
}
.max-w-full {
        max-width: 100%;
}
.max-w-none {
        max-width: none;
}
.max-w-screen-sm {
        max-width: 640px;
}
.flex-1 {
        flex: 1 1 0%;
}
.flex-auto {
        flex: 1 1 auto;
}
.flex-initial {
        flex: 0 1 auto;
}
.flex-none {
        flex: none;
}
.flex-shrink {
        flex-shrink: 1;
}
.flex-shrink-0 {
        flex-shrink: 0;
}
.shrink-0 {
        flex-shrink: 0;
}
.flex-grow {
        flex-grow: 1;
}
.flex-grow-0 {
        flex-grow: 0;
}
.grow {
        flex-grow: 1;
}
.-translate-x-1\\/2 {
        --tw-translate-x: -50%;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[80px\\] {
        --tw-translate-x: -80px;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
        --tw-translate-y: -50%;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/2 {
        --tw-translate-x: 50%;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[40px\\] {
        --tw-translate-x: 40px;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
        --tw-rotate: -90deg;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
        --tw-rotate: 180deg;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
        --tw-rotate: 45deg;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-150 {
        --tw-scale-x: 1.5;
        --tw-scale-y: 1.5;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-auto {
        cursor: auto;
}
.cursor-default {
        cursor: default;
}
.cursor-pointer {
        cursor: pointer;
}
.cursor-zoom-in {
        cursor: zoom-in;
}
.cursor-zoom-out {
        cursor: zoom-out;
}
.resize {
        resize: both;
}
.list-outside {
        list-style-position: outside;
}
.list-disc {
        list-style-type: disc;
}
.list-none {
        list-style-type: none;
}
.grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-row {
        flex-direction: row;
}
.flex-row-reverse {
        flex-direction: row-reverse;
}
.\\!flex-col {
        flex-direction: column !important;
}
.flex-col {
        flex-direction: column;
}
.flex-wrap {
        flex-wrap: wrap;
}
.place-content-center {
        place-content: center;
}
.place-content-between {
        place-content: space-between;
}
.content-center {
        align-content: center;
}
.items-start {
        align-items: flex-start;
}
.items-center {
        align-items: center;
}
.items-stretch {
        align-items: stretch;
}
.justify-start {
        justify-content: flex-start;
}
.justify-end {
        justify-content: flex-end;
}
.justify-center {
        justify-content: center;
}
.justify-between {
        justify-content: space-between;
}
.justify-around {
        justify-content: space-around;
}
.gap-0 {
        gap: 0px;
}
.gap-1 {
        gap: 0.25rem;
}
.gap-2 {
        gap: 0.5rem;
}
.gap-3 {
        gap: 0.75rem;
}
.gap-4 {
        gap: 1rem;
}
.gap-6 {
        gap: 1.5rem;
}
.gap-x-4 {
        -moz-column-gap: 1rem;
             column-gap: 1rem;
}
.gap-y-2 {
        row-gap: 0.5rem;
}
.gap-y-5 {
        row-gap: 1.25rem;
}
.gap-y-\\[31px\\] {
        row-gap: 31px;
}
.place-self-center {
        place-self: center;
}
.self-auto {
        align-self: auto;
}
.self-end {
        align-self: flex-end;
}
.self-center {
        align-self: center;
}
.overflow-auto {
        overflow: auto;
}
.\\!overflow-hidden {
        overflow: hidden !important;
}
.overflow-hidden {
        overflow: hidden;
}
.overflow-visible {
        overflow: visible;
}
.overflow-scroll {
        overflow: scroll;
}
.overflow-x-auto {
        overflow-x: auto;
}
.overflow-y-auto {
        overflow-y: auto;
}
.overflow-x-hidden {
        overflow-x: hidden;
}
.\\!overflow-x-visible {
        overflow-x: visible !important;
}
.truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
}
.text-ellipsis {
        text-overflow: ellipsis;
}
.whitespace-nowrap {
        white-space: nowrap;
}
.whitespace-pre-wrap {
        white-space: pre-wrap;
}
.break-words {
        overflow-wrap: break-word;
}
.break-all {
        word-break: break-all;
}
.rounded {
        border-radius: 0.25rem;
}
.rounded-2xl {
        border-radius: 1rem;
}
.rounded-3xl {
        border-radius: 1.5rem;
}
.rounded-\\[12px\\] {
        border-radius: 12px;
}
.rounded-\\[16px\\] {
        border-radius: 16px;
}
.rounded-\\[18px\\] {
        border-radius: 18px;
}
.rounded-\\[8px\\] {
        border-radius: 8px;
}
.rounded-full {
        border-radius: 9999px;
}
.rounded-lg {
        border-radius: 0.5rem;
}
.rounded-xl {
        border-radius: 0.75rem;
}
.rounded-b-2xl {
        border-bottom-right-radius: 1rem;
        border-bottom-left-radius: 1rem;
}
.rounded-l-lg {
        border-top-left-radius: 0.5rem;
        border-bottom-left-radius: 0.5rem;
}
.rounded-r-lg {
        border-top-right-radius: 0.5rem;
        border-bottom-right-radius: 0.5rem;
}
.rounded-t-2xl {
        border-top-left-radius: 1rem;
        border-top-right-radius: 1rem;
}
.rounded-t-\\[16px\\] {
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
}
.border {
        border-width: 1px;
}
.border-0 {
        border-width: 0px;
}
.border-2 {
        border-width: 2px;
}
.border-\\[1px\\] {
        border-width: 1px;
}
.border-\\[8px\\] {
        border-width: 8px;
}
.border-y-2 {
        border-top-width: 2px;
        border-bottom-width: 2px;
}
.border-b {
        border-bottom-width: 1px;
}
.border-b-\\[1px\\] {
        border-bottom-width: 1px;
}
.border-l {
        border-left-width: 1px;
}
.border-r {
        border-right-width: 1px;
}
.border-t {
        border-top-width: 1px;
}
.border-solid {
        border-style: solid;
}
.border-dashed {
        border-style: dashed;
}
.border-none {
        border-style: none;
}
.\\!border-neutral-notebook {
        --tw-border-opacity: 1 !important;
        border-color: rgb(220 227 239 / var(--tw-border-opacity)) !important;
}
.border-\\[\\#CFD7E5\\] {
        --tw-border-opacity: 1;
        border-color: rgb(207 215 229 / var(--tw-border-opacity));
}
.border-black {
        --tw-border-opacity: 1;
        border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-neutral-chalk {
        --tw-border-opacity: 1;
        border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-neutral-notebook {
        --tw-border-opacity: 1;
        border-color: rgb(220 227 239 / var(--tw-border-opacity));
}
.border-neutral-periwinkle {
        --tw-border-opacity: 1;
        border-color: rgb(207 215 229 / var(--tw-border-opacity));
}
.border-primary-apricot {
        --tw-border-opacity: 1;
        border-color: rgb(247 148 30 / var(--tw-border-opacity));
}
.border-primary-navyblue-bright {
        --tw-border-opacity: 1;
        border-color: rgb(102 96 185 / var(--tw-border-opacity));
}
.border-white {
        --tw-border-opacity: 1;
        border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-t-neutral-eraser {
        --tw-border-opacity: 1;
        border-top-color: rgb(180 180 180 / var(--tw-border-opacity));
}
.\\!bg-alert-error {
        --tw-bg-opacity: 1 !important;
        background-color: rgb(247 119 103 / var(--tw-bg-opacity)) !important;
}
.\\!bg-neutral-chalk {
        --tw-bg-opacity: 1 !important;
        background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.\\!bg-neutral-notebook {
        --tw-bg-opacity: 1 !important;
        background-color: rgb(220 227 239 / var(--tw-bg-opacity)) !important;
}
.\\!bg-primary-navyblue-shade {
        --tw-bg-opacity: 1 !important;
        background-color: rgb(62 58 110 / var(--tw-bg-opacity)) !important;
}
.\\!bg-white {
        --tw-bg-opacity: 1 !important;
        background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#000000\\] {
        --tw-bg-opacity: 1;
        background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-\\[\\#0755AE\\] {
        --tw-bg-opacity: 1;
        background-color: rgb(7 85 174 / var(--tw-bg-opacity));
}
.bg-\\[\\#16133E\\] {
        --tw-bg-opacity: 1;
        background-color: rgb(22 19 62 / var(--tw-bg-opacity));
}
.bg-\\[\\#16143e\\] {
        --tw-bg-opacity: 1;
        background-color: rgb(22 20 62 / var(--tw-bg-opacity));
}
.bg-\\[\\#3F3A94\\] {
        --tw-bg-opacity: 1;
        background-color: rgb(63 58 148 / var(--tw-bg-opacity));
}
.bg-\\[\\#6EBFE6\\] {
        --tw-bg-opacity: 1;
        background-color: rgb(110 191 230 / var(--tw-bg-opacity));
}
.bg-\\[\\#8099BB\\] {
        --tw-bg-opacity: 1;
        background-color: rgb(128 153 187 / var(--tw-bg-opacity));
}
.bg-\\[\\#85AEB7\\] {
        --tw-bg-opacity: 1;
        background-color: rgb(133 174 183 / var(--tw-bg-opacity));
}
.bg-\\[\\#9B9B9B\\] {
        --tw-bg-opacity: 1;
        background-color: rgb(155 155 155 / var(--tw-bg-opacity));
}
.bg-\\[\\#CB7F32\\] {
        --tw-bg-opacity: 1;
        background-color: rgb(203 127 50 / var(--tw-bg-opacity));
}
.bg-\\[\\#CFAE00\\] {
        --tw-bg-opacity: 1;
        background-color: rgb(207 174 0 / var(--tw-bg-opacity));
}
.bg-\\[\\#D4F2FF\\] {
        --tw-bg-opacity: 1;
        background-color: rgb(212 242 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#E03636\\] {
        --tw-bg-opacity: 1;
        background-color: rgb(224 54 54 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFFFFF33\\] {
        background-color: #FFFFFF33;
}
.bg-\\[\\#f5f7fc\\] {
        --tw-bg-opacity: 1;
        background-color: rgb(245 247 252 / var(--tw-bg-opacity));
}
.bg-alert-error {
        --tw-bg-opacity: 1;
        background-color: rgb(247 119 103 / var(--tw-bg-opacity));
}
.bg-gray-100 {
        --tw-bg-opacity: 1;
        background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-700 {
        --tw-bg-opacity: 1;
        background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
.bg-neutral-chalk {
        --tw-bg-opacity: 1;
        background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-neutral-chalk\\/\\[0\\.92\\] {
        background-color: rgb(255 255 255 / 0.92);
}
.bg-neutral-dust {
        --tw-bg-opacity: 1;
        background-color: rgb(160 160 160 / var(--tw-bg-opacity));
}
.bg-neutral-eraser {
        --tw-bg-opacity: 1;
        background-color: rgb(180 180 180 / var(--tw-bg-opacity));
}
.bg-neutral-graphite {
        --tw-bg-opacity: 1;
        background-color: rgb(130 126 126 / var(--tw-bg-opacity));
}
.bg-neutral-marker {
        --tw-bg-opacity: 1;
        background-color: rgb(51 51 51 / var(--tw-bg-opacity));
}
.bg-neutral-notebook\\/50 {
        background-color: rgb(220 227 239 / 0.5);
}
.bg-neutral-periwinkle {
        --tw-bg-opacity: 1;
        background-color: rgb(207 215 229 / var(--tw-bg-opacity));
}
.bg-neutral-sketchbook {
        --tw-bg-opacity: 1;
        background-color: rgb(244 247 252 / var(--tw-bg-opacity));
}
.bg-neutral-whiteboard {
        --tw-bg-opacity: 1;
        background-color: rgb(250 251 253 / var(--tw-bg-opacity));
}
.bg-primary-apricot {
        --tw-bg-opacity: 1;
        background-color: rgb(247 148 30 / var(--tw-bg-opacity));
}
.bg-primary-apricot-light {
        --tw-bg-opacity: 1;
        background-color: rgb(255 226 191 / var(--tw-bg-opacity));
}
.bg-primary-azure {
        --tw-bg-opacity: 1;
        background-color: rgb(29 130 247 / var(--tw-bg-opacity));
}
.bg-primary-black {
        --tw-bg-opacity: 1;
        background-color: rgb(35 31 32 / var(--tw-bg-opacity));
}
.bg-primary-navyblue {
        --tw-bg-opacity: 1;
        background-color: rgb(38 34 98 / var(--tw-bg-opacity));
}
.bg-primary-navyblue-bright {
        --tw-bg-opacity: 1;
        background-color: rgb(102 96 185 / var(--tw-bg-opacity));
}
.bg-primary-navyblue-bright\\/\\[0\\.65\\] {
        background-color: rgb(102 96 185 / 0.65);
}
.bg-primary-navyblue-dark {
        --tw-bg-opacity: 1;
        background-color: rgb(22 19 62 / var(--tw-bg-opacity));
}
.bg-primary-navyblue-dim {
        --tw-bg-opacity: 1;
        background-color: rgb(40 41 98 / var(--tw-bg-opacity));
}
.bg-primary-navyblue-shade {
        --tw-bg-opacity: 1;
        background-color: rgb(62 58 110 / var(--tw-bg-opacity));
}
.bg-primary-navyblue-shade\\/\\[0\\.65\\] {
        background-color: rgb(62 58 110 / 0.65);
}
.bg-primary-skyblue {
        --tw-bg-opacity: 1;
        background-color: rgb(39 170 225 / var(--tw-bg-opacity));
}
.bg-primary-skyblue-faded {
        --tw-bg-opacity: 1;
        background-color: rgb(232 248 255 / var(--tw-bg-opacity));
}
.bg-primary-skyblue-light {
        --tw-bg-opacity: 1;
        background-color: rgb(200 235 250 / var(--tw-bg-opacity));
}
.bg-success-700 {
        --tw-bg-opacity: 1;
        background-color: rgb(21 128 61 / var(--tw-bg-opacity));
}
.bg-transparent {
        background-color: transparent;
}
.bg-white {
        --tw-bg-opacity: 1;
        background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-\\[url\\(\\"\\/public\\/img\\/Background_Default_1\\.svg\\"\\)\\] {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.bg-\\[url\\(\\'\\/public\\/img\\/Background_Special\\.svg\\'\\)\\] {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.bg-\\[url\\(\\'\\/public\\/img\\/badges\\/astronaut\\.svg\\'\\)\\] {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.bg-\\[url\\(\\'\\/public\\/img\\/badges\\/background\\.svg\\'\\)\\] {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.bg-\\[url\\(\\'\\/public\\/img\\/badges\\/more_badges\\.svg\\'\\)\\] {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.bg-\\[url\\(\\'\\/public\\/img\\/exam-result\\/banner\\.svg\\'\\)\\] {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.bg-\\[url\\(\\'\\/public\\/img\\/exam-result\\/boy-figure\\.svg\\'\\)\\] {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.bg-\\[url\\(\\'\\/public\\/img\\/exam-result\\/bubble\\.svg\\'\\)\\] {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.bg-\\[url\\(\\'\\/public\\/img\\/exam-result\\/jc-banner\\.svg\\'\\)\\] {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.bg-\\[url\\(\\'\\/src\\/assets\\/background\\/Background_Default_1\\.svg\\'\\)\\] {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.bg-gradient-to-r {
        background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-none {
        background-image: none;
}
.from-\\[\\#018BC4\\] {
        --tw-gradient-from: #018BC4 var(--tw-gradient-from-position);
        --tw-gradient-to: rgb(1 139 196 / 0) var(--tw-gradient-to-position);
        --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#3F39A2\\] {
        --tw-gradient-from: #3F39A2 var(--tw-gradient-from-position);
        --tw-gradient-to: rgb(63 57 162 / 0) var(--tw-gradient-to-position);
        --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-neutral-chalk {
        --tw-gradient-from: #FFFFFF var(--tw-gradient-from-position);
        --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
        --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-neutral-sketchbook {
        --tw-gradient-from: #F4F7FC var(--tw-gradient-from-position);
        --tw-gradient-to: rgb(244 247 252 / 0) var(--tw-gradient-to-position);
        --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-\\[\\#19A2C0\\] {
        --tw-gradient-to: #19A2C0 var(--tw-gradient-to-position);
}
.to-\\[\\#8F4690\\] {
        --tw-gradient-to: #8F4690 var(--tw-gradient-to-position);
}
.bg-contain {
        background-size: contain;
}
.bg-cover {
        background-size: cover;
}
.bg-fixed {
        background-attachment: fixed;
}
.bg-clip-text {
        -webkit-background-clip: text;
                background-clip: text;
}
.bg-\\[-10px\\] {
        background-position: -10px;
}
.bg-\\[45\\%_75\\%\\] {
        background-position: 45% 75%;
}
.bg-center {
        background-position: center;
}
.bg-left-bottom {
        background-position: left bottom;
}
.bg-no-repeat {
        background-repeat: no-repeat;
}
.fill-\\[\\#D4F2FF\\] {
        fill: #D4F2FF;
}
.fill-current {
        fill: currentColor;
}
.fill-primary-apricot {
        fill: #F7941E;
}
.stroke-neutral-chalk {
        stroke: #FFFFFF;
}
.stroke-\\[20\\] {
        stroke-width: 20;
}
.object-contain {
        -o-object-fit: contain;
           object-fit: contain;
}
.object-none {
        -o-object-fit: none;
           object-fit: none;
}
.object-left-bottom {
        -o-object-position: left bottom;
           object-position: left bottom;
}
.\\!p-8 {
        padding: 2rem !important;
}
.p-0 {
        padding: 0px;
}
.p-1 {
        padding: 0.25rem;
}
.p-1\\.5 {
        padding: 0.375rem;
}
.p-2 {
        padding: 0.5rem;
}
.p-3 {
        padding: 0.75rem;
}
.p-4 {
        padding: 1rem;
}
.p-6 {
        padding: 1.5rem;
}
.p-8 {
        padding: 2rem;
}
.p-\\[8px\\] {
        padding: 8px;
}
.\\!px-0 {
        padding-left: 0px !important;
        padding-right: 0px !important;
}
.\\!px-2 {
        padding-left: 0.5rem !important;
        padding-right: 0.5rem !important;
}
.\\!px-4 {
        padding-left: 1rem !important;
        padding-right: 1rem !important;
}
.\\!px-6 {
        padding-left: 1.5rem !important;
        padding-right: 1.5rem !important;
}
.\\!px-8 {
        padding-left: 2rem !important;
        padding-right: 2rem !important;
}
.\\!px-\\[24px\\] {
        padding-left: 24px !important;
        padding-right: 24px !important;
}
.\\!py-0 {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
}
.\\!py-2 {
        padding-top: 0.5rem !important;
        padding-bottom: 0.5rem !important;
}
.\\!py-6 {
        padding-top: 1.5rem !important;
        padding-bottom: 1.5rem !important;
}
.\\!py-\\[12px\\] {
        padding-top: 12px !important;
        padding-bottom: 12px !important;
}
.px-1 {
        padding-left: 0.25rem;
        padding-right: 0.25rem;
}
.px-10 {
        padding-left: 2.5rem;
        padding-right: 2.5rem;
}
.px-12 {
        padding-left: 3rem;
        padding-right: 3rem;
}
.px-2 {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
}
.px-3 {
        padding-left: 0.75rem;
        padding-right: 0.75rem;
}
.px-4 {
        padding-left: 1rem;
        padding-right: 1rem;
}
.px-5 {
        padding-left: 1.25rem;
        padding-right: 1.25rem;
}
.px-6 {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
}
.px-8 {
        padding-left: 2rem;
        padding-right: 2rem;
}
.px-\\[16px\\] {
        padding-left: 16px;
        padding-right: 16px;
}
.px-\\[20px\\] {
        padding-left: 20px;
        padding-right: 20px;
}
.px-\\[24px\\] {
        padding-left: 24px;
        padding-right: 24px;
}
.px-\\[32px\\] {
        padding-left: 32px;
        padding-right: 32px;
}
.px-\\[38px\\] {
        padding-left: 38px;
        padding-right: 38px;
}
.px-\\[42px\\] {
        padding-left: 42px;
        padding-right: 42px;
}
.py-0 {
        padding-top: 0px;
        padding-bottom: 0px;
}
.py-0\\.5 {
        padding-top: 0.125rem;
        padding-bottom: 0.125rem;
}
.py-1 {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
}
.py-2 {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
}
.py-2\\.5 {
        padding-top: 0.625rem;
        padding-bottom: 0.625rem;
}
.py-3 {
        padding-top: 0.75rem;
        padding-bottom: 0.75rem;
}
.py-3\\.5 {
        padding-top: 0.875rem;
        padding-bottom: 0.875rem;
}
.py-4 {
        padding-top: 1rem;
        padding-bottom: 1rem;
}
.py-6 {
        padding-top: 1.5rem;
        padding-bottom: 1.5rem;
}
.py-8 {
        padding-top: 2rem;
        padding-bottom: 2rem;
}
.py-\\[14px\\] {
        padding-top: 14px;
        padding-bottom: 14px;
}
.py-\\[16px\\] {
        padding-top: 16px;
        padding-bottom: 16px;
}
.py-\\[1px\\] {
        padding-top: 1px;
        padding-bottom: 1px;
}
.py-\\[24px\\] {
        padding-top: 24px;
        padding-bottom: 24px;
}
.py-\\[2px\\] {
        padding-top: 2px;
        padding-bottom: 2px;
}
.py-\\[39px\\] {
        padding-top: 39px;
        padding-bottom: 39px;
}
.\\!pb-0 {
        padding-bottom: 0px !important;
}
.\\!pb-6 {
        padding-bottom: 1.5rem !important;
}
.\\!pb-\\[75px\\] {
        padding-bottom: 75px !important;
}
.\\!pt-2 {
        padding-top: 0.5rem !important;
}
.pb-4 {
        padding-bottom: 1rem;
}
.pb-5 {
        padding-bottom: 1.25rem;
}
.pb-6 {
        padding-bottom: 1.5rem;
}
.pb-8 {
        padding-bottom: 2rem;
}
.pb-\\[108px\\] {
        padding-bottom: 108px;
}
.pb-\\[24px\\] {
        padding-bottom: 24px;
}
.pb-\\[30px\\] {
        padding-bottom: 30px;
}
.pb-\\[8px\\] {
        padding-bottom: 8px;
}
.pl-1 {
        padding-left: 0.25rem;
}
.pl-2 {
        padding-left: 0.5rem;
}
.pl-24 {
        padding-left: 6rem;
}
.pl-4 {
        padding-left: 1rem;
}
.pl-8 {
        padding-left: 2rem;
}
.pl-\\[140px\\] {
        padding-left: 140px;
}
.pl-\\[158px\\] {
        padding-left: 158px;
}
.pl-\\[15px\\] {
        padding-left: 15px;
}
.pl-\\[2px\\] {
        padding-left: 2px;
}
.pr-1 {
        padding-right: 0.25rem;
}
.pr-2 {
        padding-right: 0.5rem;
}
.pr-24 {
        padding-right: 6rem;
}
.pr-4 {
        padding-right: 1rem;
}
.pr-5 {
        padding-right: 1.25rem;
}
.pr-6 {
        padding-right: 1.5rem;
}
.pr-8 {
        padding-right: 2rem;
}
.pt-0 {
        padding-top: 0px;
}
.pt-0\\.5 {
        padding-top: 0.125rem;
}
.pt-1 {
        padding-top: 0.25rem;
}
.pt-10 {
        padding-top: 2.5rem;
}
.pt-2 {
        padding-top: 0.5rem;
}
.pt-3 {
        padding-top: 0.75rem;
}
.pt-4 {
        padding-top: 1rem;
}
.pt-6 {
        padding-top: 1.5rem;
}
.pt-\\[16px\\] {
        padding-top: 16px;
}
.pt-\\[2px\\] {
        padding-top: 2px;
}
.pt-\\[6px\\] {
        padding-top: 6px;
}
.text-left {
        text-align: left;
}
.text-center {
        text-align: center;
}
.text-right {
        text-align: right;
}
.align-baseline {
        vertical-align: baseline;
}
.align-top {
        vertical-align: top;
}
.align-middle {
        vertical-align: middle;
}
.align-bottom {
        vertical-align: bottom;
}
.align-text-top {
        vertical-align: text-top;
}
.align-super {
        vertical-align: super;
}
.font-\\[\\'Open_Sans\\'\\] {
        font-family: 'Open Sans';
}
.\\!text-\\[13px\\] {
        font-size: 13px !important;
}
.\\!text-sm {
        font-size: 14px !important;
}
.text-\\[1\\.125rem\\] {
        font-size: 1.125rem;
}
.text-\\[10px\\] {
        font-size: 10px;
}
.text-\\[12px\\] {
        font-size: 12px;
}
.text-\\[14px\\] {
        font-size: 14px;
}
.text-\\[16px\\] {
        font-size: 16px;
}
.text-\\[1rem\\] {
        font-size: 1rem;
}
.text-\\[20px\\] {
        font-size: 20px;
}
.text-\\[24px\\] {
        font-size: 24px;
}
.text-\\[32px\\] {
        font-size: 32px;
}
.text-\\[34px\\] {
        font-size: 34px;
}
.text-\\[48px\\] {
        font-size: 48px;
}
.text-lg {
        font-size: 20px;
}
.text-md {
        font-size: 16px;
}
.text-sm {
        font-size: 14px;
}
.text-xl {
        font-size: 24px;
}
.text-xs {
        font-size: 12px;
}
.text-xxl {
        font-size: 34px;
}
.text-xxs {
        font-size: 10px;
}
.\\!font-black {
        font-weight: 900 !important;
}
.\\!font-bold {
        font-weight: 700 !important;
}
.\\!font-extrabold {
        font-weight: 800 !important;
}
.font-black {
        font-weight: 900;
}
.font-bold {
        font-weight: 700;
}
.font-extrabold {
        font-weight: 800;
}
.font-light {
        font-weight: 300;
}
.font-medium {
        font-weight: 500;
}
.font-normal {
        font-weight: 400;
}
.font-semibold {
        font-weight: 600;
}
.font-thin {
        font-weight: 100;
}
.uppercase {
        text-transform: uppercase;
}
.capitalize {
        text-transform: capitalize;
}
.\\!leading-3 {
        line-height: .75rem !important;
}
.\\!leading-5 {
        line-height: 1.25rem !important;
}
.\\!leading-\\[1\\.2\\] {
        line-height: 1.2 !important;
}
.leading-10 {
        line-height: 2.5rem;
}
.leading-3 {
        line-height: .75rem;
}
.leading-3\\.5 {
        line-height: 14px;
}
.leading-4 {
        line-height: 1rem;
}
.leading-5 {
        line-height: 1.25rem;
}
.leading-6 {
        line-height: 1.5rem;
}
.leading-7 {
        line-height: 1.75rem;
}
.leading-8 {
        line-height: 2rem;
}
.leading-\\[1\\.2\\] {
        line-height: 1.2;
}
.leading-\\[1\\.5\\] {
        line-height: 1.5;
}
.leading-\\[10px\\] {
        line-height: 10px;
}
.leading-\\[14px\\] {
        line-height: 14px;
}
.leading-\\[16px\\] {
        line-height: 16px;
}
.leading-\\[19px\\] {
        line-height: 19px;
}
.leading-\\[21px\\] {
        line-height: 21px;
}
.leading-\\[24px\\] {
        line-height: 24px;
}
.leading-\\[26px\\] {
        line-height: 26px;
}
.leading-\\[27px\\] {
        line-height: 27px;
}
.leading-\\[32px\\] {
        line-height: 32px;
}
.leading-\\[34px\\] {
        line-height: 34px;
}
.leading-\\[35px\\] {
        line-height: 35px;
}
.leading-\\[46px\\] {
        line-height: 46px;
}
.leading-\\[54px\\] {
        line-height: 54px;
}
.leading-normal {
        line-height: 1.5;
}
.leading-snug {
        line-height: 1.375;
}
.\\!text-alert-error {
        --tw-text-opacity: 1 !important;
        color: rgb(247 119 103 / var(--tw-text-opacity)) !important;
}
.\\!text-neutral-chalk {
        --tw-text-opacity: 1 !important;
        color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.\\!text-neutral-pencil {
        --tw-text-opacity: 1 !important;
        color: rgb(81 81 81 / var(--tw-text-opacity)) !important;
}
.\\!text-primary-apricot {
        --tw-text-opacity: 1 !important;
        color: rgb(247 148 30 / var(--tw-text-opacity)) !important;
}
.\\!text-primary-neptune-dark {
        --tw-text-opacity: 1 !important;
        color: rgb(48 80 141 / var(--tw-text-opacity)) !important;
}
.\\!text-primary-skyblue {
        --tw-text-opacity: 1 !important;
        color: rgb(39 170 225 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#262262\\] {
        --tw-text-opacity: 1;
        color: rgb(38 34 98 / var(--tw-text-opacity));
}
.text-\\[\\#476DB3\\] {
        --tw-text-opacity: 1;
        color: rgb(71 109 179 / var(--tw-text-opacity));
}
.text-\\[\\#72CC7C\\] {
        --tw-text-opacity: 1;
        color: rgb(114 204 124 / var(--tw-text-opacity));
}
.text-\\[\\#A0E274\\] {
        --tw-text-opacity: 1;
        color: rgb(160 226 116 / var(--tw-text-opacity));
}
.text-\\[\\#B4B4B4\\] {
        --tw-text-opacity: 1;
        color: rgb(180 180 180 / var(--tw-text-opacity));
}
.text-\\[\\#C3CAD6\\] {
        --tw-text-opacity: 1;
        color: rgb(195 202 214 / var(--tw-text-opacity));
}
.text-\\[\\#EF4A46\\] {
        --tw-text-opacity: 1;
        color: rgb(239 74 70 / var(--tw-text-opacity));
}
.text-\\[\\#F56468\\] {
        --tw-text-opacity: 1;
        color: rgb(245 100 104 / var(--tw-text-opacity));
}
.text-\\[\\#F6C483\\] {
        --tw-text-opacity: 1;
        color: rgb(246 196 131 / var(--tw-text-opacity));
}
.text-\\[\\#FED00B\\] {
        --tw-text-opacity: 1;
        color: rgb(254 208 11 / var(--tw-text-opacity));
}
.text-alert-error {
        --tw-text-opacity: 1;
        color: rgb(247 119 103 / var(--tw-text-opacity));
}
.text-alert-success {
        --tw-text-opacity: 1;
        color: rgb(72 160 116 / var(--tw-text-opacity));
}
.text-alert-warning {
        --tw-text-opacity: 1;
        color: rgb(254 208 11 / var(--tw-text-opacity));
}
.text-error-500 {
        --tw-text-opacity: 1;
        color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-neutral-chalk {
        --tw-text-opacity: 1;
        color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-neutral-dust {
        --tw-text-opacity: 1;
        color: rgb(160 160 160 / var(--tw-text-opacity));
}
.text-neutral-eraser {
        --tw-text-opacity: 1;
        color: rgb(180 180 180 / var(--tw-text-opacity));
}
.text-neutral-graphite {
        --tw-text-opacity: 1;
        color: rgb(130 126 126 / var(--tw-text-opacity));
}
.text-neutral-marker {
        --tw-text-opacity: 1;
        color: rgb(51 51 51 / var(--tw-text-opacity));
}
.text-neutral-pencil {
        --tw-text-opacity: 1;
        color: rgb(81 81 81 / var(--tw-text-opacity));
}
.text-neutral-periwinkle {
        --tw-text-opacity: 1;
        color: rgb(207 215 229 / var(--tw-text-opacity));
}
.text-neutral-whiteboard {
        --tw-text-opacity: 1;
        color: rgb(250 251 253 / var(--tw-text-opacity));
}
.text-neutral-whiteboard\\/50 {
        color: rgb(250 251 253 / 0.5);
}
.text-primary-apricot {
        --tw-text-opacity: 1;
        color: rgb(247 148 30 / var(--tw-text-opacity));
}
.text-primary-apricot-dark {
        --tw-text-opacity: 1;
        color: rgb(229 123 65 / var(--tw-text-opacity));
}
.text-primary-navyblue {
        --tw-text-opacity: 1;
        color: rgb(38 34 98 / var(--tw-text-opacity));
}
.text-primary-navyblue-bright {
        --tw-text-opacity: 1;
        color: rgb(102 96 185 / var(--tw-text-opacity));
}
.text-primary-navyblue-dark {
        --tw-text-opacity: 1;
        color: rgb(22 19 62 / var(--tw-text-opacity));
}
.text-primary-navyblue-dim {
        --tw-text-opacity: 1;
        color: rgb(40 41 98 / var(--tw-text-opacity));
}
.text-primary-navyblue-faded {
        --tw-text-opacity: 1;
        color: rgb(206 205 242 / var(--tw-text-opacity));
}
.text-primary-navyblue-shade {
        --tw-text-opacity: 1;
        color: rgb(62 58 110 / var(--tw-text-opacity));
}
.text-primary-skyblue {
        --tw-text-opacity: 1;
        color: rgb(39 170 225 / var(--tw-text-opacity));
}
.text-primary-skyblue-faded {
        --tw-text-opacity: 1;
        color: rgb(232 248 255 / var(--tw-text-opacity));
}
.text-transparent {
        color: transparent;
}
.text-white {
        --tw-text-opacity: 1;
        color: rgb(255 255 255 / var(--tw-text-opacity));
}
.underline {
        text-decoration-line: underline;
}
.decoration-dashed {
        text-decoration-style: dashed;
}
.opacity-0 {
        opacity: 0;
}
.opacity-20 {
        opacity: 0.2;
}
.opacity-50 {
        opacity: 0.5;
}
.shadow-\\[0_3px_15px_0_\\#27AAE166\\] {
        --tw-shadow: 0 3px 15px 0 #27AAE166;
        --tw-shadow-colored: 0 3px 15px 0 var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_24px_0px_rgba\\(255\\2c 255\\2c 255\\2c 0\\.20\\)\\] {
        --tw-shadow: 0px 0px 24px 0px rgba(255,255,255,0.20);
        --tw-shadow-colored: 0px 0px 24px 0px var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_12px_0px_0px_\\#2CA2DB\\] {
        --tw-shadow: 0px 12px 0px 0px #2CA2DB;
        --tw-shadow-colored: 0px 12px 0px 0px var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_8px_0px_0px_\\#282661\\] {
        --tw-shadow: 0px 8px 0px 0px #282661;
        --tw-shadow-colored: 0px 8px 0px 0px var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[4px_-4px_0_0_\\#CFD7E5_inset\\] {
        --tw-shadow: 4px -4px 0 0 #CFD7E5 inset;
        --tw-shadow-colored: inset 4px -4px 0 0 var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
        --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
        --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
        --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
        --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
        outline-style: solid;
}
.ring-2 {
        --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
        box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-primary-apricot {
        --tw-ring-opacity: 1;
        --tw-ring-color: rgb(247 148 30 / var(--tw-ring-opacity));
}
.ring-opacity-50 {
        --tw-ring-opacity: 0.5;
}
.blur {
        --tw-blur: blur(8px);
        filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
        filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!backdrop-blur-0 {
        --tw-backdrop-blur: blur(0) !important;
        -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
                backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.backdrop-blur-sm {
        --tw-backdrop-blur: blur(4px);
        -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
                backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
        transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
        transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
        transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 150ms;
}
.transition-all {
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 150ms;
}
    .no-scroll {
        -ms-overflow-style: none;  /* Internet Explorer 10+ */
        scrollbar-width: none;  /* Firefox */
    }
    .no-scroll::-webkit-scrollbar {
        display: none;  /* Safari and Chrome */
    }

    .mock-exam-layout .cb-focus input {
        display: none;
}

    .mock-exam-layout .tablet-illustration {
        margin-bottom: -10px;
        margin-top: 10px;
}

    @media not all and (min-width: 640px) {
        .mock-exam-layout .tablet-illustration {
                display: none;
        }
}

    @media (min-width: 1024px) {
        .mock-exam-layout .tablet-illustration {
                display: none;
        }
}

    .mock-exam-layout .phone-illustration {
        margin: auto;
        margin-bottom: -9px;
        margin-top: 20px;
        max-width: 336px;
}

    @media (min-width: 640px) {
        .mock-exam-layout .phone-illustration {
                display: none;
        }
}

    @media (max-width: 400px) {
        .mock-exam-layout .phone-illustration {
                margin-bottom: -19px;
                max-width: 240px;
        }
}

    @media (max-width: 300px) {
        .mock-exam-layout .phone-illustration {
                display: none;
        }
}
    .mock-exam-layout .progress-container {
        margin-left: auto;
        margin-right: auto;
        width: 90%;
}
    @media not all and (min-width: 1024px) {
        .mock-exam-layout .progress-container {
                padding-top: 20px;
                padding-bottom: 20px;
        }
}
    .mock-exam-layout .progress-container {
        width: 60%;
        padding-top: 20px;
        padding-bottom: 20px;
}
    @media (min-width: 1024px) {
        .mock-exam-layout .progress-container {
                min-width: 343px;
        }
}
    .mock-exam-layout .container-form {
        width: 91%;
        border-radius: 1rem;
        --tw-bg-opacity: 1;
        background-color: rgb(255 255 255 / var(--tw-bg-opacity));
        padding: 40px;
}
    @media (min-width: 1024px) {
        .mock-exam-layout .container-form {
                min-width: 343px;
        }
}
    @media not all and (min-width: 1024px) {
        .mock-exam-layout .container-form {
                width: 100%;
                padding: 40px;
        }
}
    @media not all and (min-width: 640px) {
        .mock-exam-layout .container-form {
                padding-left: 24px;
                padding-right: 24px;
        }
}

    .mock-exam-layout .container-selector {
        width: 90%;
        text-align: left;
}

    @media (min-width: 1024px) {
        .mock-exam-layout .container-selector {
                min-width: 343px;
        }
}

    @media not all and (min-width: 1024px) {
        .mock-exam-layout .container-selector {
                width: 100%;
                padding-top: 40px;
                padding-bottom: 40px;
        }
}

    @media (min-width: 1024px) {
        .mock-exam-layout .container-selector {
                margin-top: -70px;
                margin-left: 30px;
        }
}

    .mock-exam-layout .link-text a {
        display: inline !important;
        font-size: 14px !important;
}

    .mock-exam-layout .forgot-back {
        margin-bottom: 17px;
        display: inline !important;
        display: flex !important;
        fill: currentColor;
        text-align: left;
        --tw-text-opacity: 1;
        color: rgb(247 148 30 / var(--tw-text-opacity));
}
    .mock-exam-layout .forgot-back-hover svg {
        fill: currentColor;
        --tw-text-opacity: 1 !important;
        color: rgb(39 170 225 / var(--tw-text-opacity)) !important;
}
    .mock-exam-layout .forgot-back-hover a {
        --tw-text-opacity: 1;
        color: rgb(39 170 225 / var(--tw-text-opacity));
}

    .mock-exam-layout a.back-mobile {
        display: none;
        font-size: 16px;
        font-weight: 700;
}

    @media not all and (min-width: 1024px) {
        .mock-exam-layout a.back-mobile {
                display: block;
        }
}

    .mock-exam-layout .header-container {
        height: 4rem;
}

    @media not all and (min-width: 1024px) {
        .mock-exam-layout .header-container {
                z-index: 20;
                display: flex;
                justify-content: center;
                padding-left: 0px;
        }
}

    .mock-exam-layout .body-container {
        height: calc(100vh - 64px);
        min-height: 100vh;
        padding-top: 4rem;
}

    .mock-exam-layout .animation-container {
        min-height: 100%;
}

    @media not all and (min-width: 1024px) {
        .mock-exam-layout .animation-container {
                min-height: auto;
        }
}

    .mock-exam-layout .form-container {
        height: 100%;
        min-height: calc(100vh - 64px);
        align-items: flex-start;
        padding-top: 2.5rem;
        padding-bottom: 2.5rem;
}

    @media not all and (min-width: 1024px) {
        .mock-exam-layout .form-container {
                padding-top: 1.5rem;
                padding-bottom: 1.5rem;
                height: auto;
                min-height: auto;
                align-items: center;
        }
}

    .mock-exam-layout .mock-exam-left-container, .mock-exam-layout .webinar-left-container {
        width: 100%;
        padding-right: 54px;
}

    @media not all and (min-width: 1024px) {
        .mock-exam-layout .mock-exam-left-container, .mock-exam-layout .webinar-left-container {
                padding-right: 0px;
        }
}

    .mock-exam-layout .mock-exam-left-content {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
        margin-top: 2.5rem;
        width: 100%;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        padding-bottom: 100%;
    }

    .mock-exam-layout .webinar-left-content {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
        margin-top: 2.5rem;
        width: 100%;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        padding-bottom: 100%;
    }

    @media not all and (min-width: 1024px) {
        .mock-exam-layout .webinar-left-content {
                margin-left: auto;
                margin-right: auto;
                height: 523px;
                width: 546px;
        padding-bottom: unset;
        }
}

    @media not all and (min-width: 640px) {
        .mock-exam-layout .webinar-left-content {
                height: 334px;
                width: 323px;
        }
}

    @media not all and (min-width: 1024px) {
        .mock-exam-layout.mock-exam-get-started .animation-container,
    .mock-exam-layout.webinar-payment .animation-container,
    .mock-exam-layout.webinar-welcome .animation-container,
    .mock-exam-layout.webinar-payment .form-container {
                position: relative;
                z-index: 10;
                margin-left: -110px;
                display: flex;
                width: 100vw;
                max-width: none;
        }
}

    @media not all and (min-width: 640px) {
        .mock-exam-layout.mock-exam-get-started .animation-container,
    .mock-exam-layout.webinar-payment .animation-container,
    .mock-exam-layout.webinar-welcome .animation-container,
    .mock-exam-layout.webinar-payment .form-container {
                margin-left: -15px;
        }
}

    @media not all and (min-width: 1024px) {
        .mock-exam-layout.mock-exam-get-started .body-container,
    .mock-exam-layout.webinar-welcome .body-container,
    .mock-exam-layout.webinar-payment .body-container {
                display: block;
        }
}

    .mock-exam-layout.mock-exam-get-started .form-container {
        padding-left: 2.5rem;
        padding-top: 110px;
}

    @media not all and (min-width: 1024px) {
        .mock-exam-layout.mock-exam-get-started .form-container {
                width: 100%;
                max-width: none;
                padding-top: 3.5rem;
                padding-bottom: 3.5rem;
                padding-left: 0px;
        }
}

    @media not all and (min-width: 640px) {
        .mock-exam-layout.mock-exam-get-started .form-container {
                padding-top: 1rem;
                padding-bottom: 1rem;
        }
}

    .mock-exam-layout .auth-layout-background {
        display: none;
}

    .mock-exam-background {
        display: none;
}

    @media not all and (min-width: 1024px) {
        .mock-exam-background {
                position: fixed;
                bottom: 0px;
                z-index: -1;
                display: block;
                max-width: 580px;
        }
}

    @media not all and (min-width: 640px) {
        .mock-exam-background {
                width: 91.666667%;
                max-width: 485px;
        }
}

    /* Webinar */
    @media not all and (min-width: 1024px) {
        .mock-exam-layout.webinar-welcome .form-container {
                width: 100%;
                max-width: none;
                padding-top: 3.5rem;
                padding-bottom: 3.5rem;
        }
}
    @media not all and (min-width: 640px) {
        .mock-exam-layout.webinar-welcome .form-container {
                padding-top: 1rem;
                padding-bottom: 1rem;
        }
}

    @media not all and (min-width: 1024px) {
        .mock-exam-layout.webinar-welcome .container-form {
                margin-top: -37px;
        }
}

    @media not all and (min-width: 640px) {
        .mock-exam-layout.webinar-welcome .container-form {
                margin-top: -22px;
        }
}

    .webinar-payment-title {
        margin-bottom: 1rem;
        font-size: 24px;
        font-weight: 900;
        line-height: 32px;
        --tw-text-opacity: 1;
        color: rgb(38 34 98 / var(--tw-text-opacity));
        display: flex;
        align-items: center;
        justify-content: flex-start;
}

    @media not all and (min-width: 1024px) {
        .webinar-payment-title {
                display: none;
        }
}

    .webinar-payment-label {
        font-size: 14px;
        font-weight: 900;
        text-transform: uppercase;
        line-height: 1.25rem;
        --tw-text-opacity: 1;
        color: rgb(180 180 180 / var(--tw-text-opacity));
}

    @media not all and (min-width: 1024px) {
        .webinar-payment-label {
                margin-top: 1.5rem;
                padding-left: 4rem;
                padding-right: 4rem;
        }
}

    @media not all and (min-width: 640px) {
        .webinar-payment-label {
                padding-left: 1rem;
                padding-right: 1rem;
        }
}

    @media not all and (min-width: 1024px) {
        .webinar-payment-separator {
                border-bottom-width: 8px;
                border-style: solid;
                --tw-border-opacity: 1;
                border-color: rgb(220 227 239 / var(--tw-border-opacity));
        }
}

    .mock-exam-layout.mock-exam-layout.webinar-payment .auth-layout-background {
        display: none;
}

    .mock-exam-layout.webinar-payment .container-form {
        margin-bottom: 2.5rem;
}

    @media not all and (min-width: 1024px) {
        .mock-exam-layout.webinar-payment .container-form {
                margin-bottom: 0px;
                background-color: transparent;
                padding: 0px;
        }
        .mock-exam-layout.webinar-payment .form-container {
                padding-top: 0px;
                padding-bottom: 0px;
        }
        .webinar-address-container {
                margin-top: 1.5rem;
                margin-bottom: 1.5rem;
                padding-left: 4rem;
                padding-right: 4rem;
        }

    @media not all and (min-width: 1024px) {
                .webinar-address-container {
                        border-bottom-width: 8px;
                        border-style: solid;
                        --tw-border-opacity: 1;
                        border-color: rgb(220 227 239 / var(--tw-border-opacity));
                }
        }
}

    @media not all and (min-width: 640px) {
        .webinar-address-container {
                padding-left: 1rem;
                padding-right: 1rem;
        }
}

    .mock-exam-layout.webinar-payment .webinar-payment-frame-container {
        margin-left: -0.75rem;
        margin-right: -0.75rem;
        margin-top: 1rem;
}

    @media not all and (min-width: 1024px) {
        .mock-exam-layout.webinar-payment .webinar-payment-frame-container {
                margin-bottom: 1.5rem;
                padding-left: 4rem;
                padding-right: 4rem;
                padding-bottom: 1.5rem;
        }

    @media not all and (min-width: 1024px) {
                .mock-exam-layout.webinar-payment .webinar-payment-frame-container {
                        border-bottom-width: 8px;
                        border-style: solid;
                        --tw-border-opacity: 1;
                        border-color: rgb(220 227 239 / var(--tw-border-opacity));
                }
        }
}

    @media not all and (min-width: 640px) {
        .mock-exam-layout.webinar-payment .webinar-payment-frame-container {
                padding-left: 1rem;
                padding-right: 1rem;
        }
}

    .webinar-payment-checkbox-container {
        margin-top: 2rem;
        display: flex;
        align-items: flex-start;
}

    @media not all and (min-width: 1024px) {
        .webinar-payment-checkbox-container {
                margin-bottom: 10px;
                margin-top: 0px;
                padding-left: 4rem;
                padding-right: 4rem;
                padding-bottom: 371px;
        }
}

    @media not all and (min-width: 640px) {
        .webinar-payment-checkbox-container {
                padding-left: 1rem;
                padding-right: 1rem;
        }
}

    .webinar-payment-floating-footer {
        position: fixed;
        left: 0px;
        right: 0px;
        bottom: 0px;
        display: none;
        border-top-left-radius: 1rem;
        border-top-right-radius: 1rem;
        --tw-bg-opacity: 1;
        background-color: rgb(255 255 255 / var(--tw-bg-opacity));
        padding-top: 1.5rem;
        padding-bottom: 27px;
}

    @media not all and (min-width: 1024px) {
        .webinar-payment-floating-footer {
                display: block;
        }
}

    .webinar-payment-detail {
        margin-bottom: 1.5rem;
        display: flex;
        align-items: center;
        justify-content: flex-start;
}

    .webinar-payment-floating-footer .webinar-payment-detail p {
        padding-left: 4rem;
        padding-right: 4rem;
        font-size: 24px;
        font-weight: 700;
        line-height: 35px;
        --tw-text-opacity: 1;
        color: rgb(38 34 98 / var(--tw-text-opacity));
}

    @media not all and (min-width: 640px) {
        .webinar-payment-floating-footer .webinar-payment-detail p {
                padding-left: 1rem;
                padding-right: 1rem;
        }
}

    .webinar-payment-floating-footer button {
        padding-left: 4rem;
        padding-right: 4rem;
}

    @media not all and (min-width: 640px) {
        .webinar-payment-floating-footer button {
                padding-left: 1rem;
                padding-right: 1rem;
        }
}

    .webinar-payment-floating-footer > p {
        margin-top: 1.5rem;
        padding-left: 4rem;
        padding-right: 4rem;
        font-size: 12px;
        font-weight: 500;
        --tw-text-opacity: 1;
        color: rgb(81 81 81 / var(--tw-text-opacity));
}

    @media not all and (min-width: 640px) {
        .webinar-payment-floating-footer > p {
                padding-left: 1rem;
                padding-right: 1rem;
        }
}

    .mock-exam-layout.webinar-payment {
        position: fixed;
        overflow-y: auto;
        overflow-x: hidden;
}

    .webinar-snackbar .message-button {
        margin-left: 0px;
}

    .webinar-snackbar > div > .max-w-full {
        display: flex;
}

    .webinar-snackbar > div > .\\!max-w-full {
        display: flex;
}

    .webinar-snackbar > div > .max-w-full > .float-left {
        padding-right: 2rem;
}

    @media not all and (min-width: 640px) {
        .webinar-snackbar > div > .max-w-full > .float-left {
                padding-right: 1rem;
        }
}

    .webinar-snackbar > div > .\\!max-w-full > .float-left {
        padding-right: 2rem;
}

    @media not all and (min-width: 640px) {
        .webinar-snackbar > div > .\\!max-w-full > .float-left {
                padding-right: 1rem;
        }
}

    .webinar-snackbar .icon-container, .webinar-snackbar > div > .max-w-full > .float-right {
        display: flex;
        align-items: center;
}

     .webinar-snackbar > div > .\\!max-w-full > .float-right {
        display: flex;
        align-items: center;
}

    .payment-failed-popup div.popup-container {
        padding-left: 34px;
        padding-right: 34px;
}

    .marker\\:text-primary-apricot *::marker {
        color: rgb(247 148 30 );
}

    .marker\\:text-primary-apricot::marker {
        color: rgb(247 148 30 );
}

    .before\\:fixed::before {
        content: var(--tw-content);
        position: fixed;
}

    .before\\:left-0::before {
        content: var(--tw-content);
        left: 0px;
}

    .before\\:top-16::before {
        content: var(--tw-content);
        top: 4rem;
}

    .before\\:-z-10::before {
        content: var(--tw-content);
        z-index: -10;
}

    .before\\:h-\\[calc\\(100\\%\\+76px\\)\\]::before {
        content: var(--tw-content);
        height: calc(100% + 76px);
}

    .before\\:w-screen::before {
        content: var(--tw-content);
        width: 100vw;
}

    .before\\:bg-primary-navyblue-dark::before {
        content: var(--tw-content);
        --tw-bg-opacity: 1;
        background-color: rgb(22 19 62 / var(--tw-bg-opacity));
}

    .before\\:bg-\\[url\\(\\'\\/public\\/img\\/Background_Default_1\\.svg\\'\\)\\]::before {
        content: var(--tw-content);
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

    .before\\:bg-cover::before {
        content: var(--tw-content);
        background-size: cover;
}

    .before\\:bg-fixed::before {
        content: var(--tw-content);
        background-attachment: fixed;
}

    .before\\:bg-\\[6\\.5\\%_41\\%\\]::before {
        content: var(--tw-content);
        background-position: 6.5% 41%;
}

    .before\\:bg-no-repeat::before {
        content: var(--tw-content);
        background-repeat: no-repeat;
}

    .last\\:\\!col-span-2:last-child {
        grid-column: span 2 / span 2 !important;
}

    .last\\:mb-0:last-child {
        margin-bottom: 0px;
}

    .last\\:mr-0:last-child {
        margin-right: 0px;
}

    .last\\:pb-0:last-child {
        padding-bottom: 0px;
}

    .first-of-type\\:mt-2:first-of-type {
        margin-top: 0.5rem;
}

    .last-of-type\\:mb-0:last-of-type {
        margin-bottom: 0px;
}

    .last-of-type\\:\\!pb-0:last-of-type {
        padding-bottom: 0px !important;
}

    .focus-within\\:text-primary-apricot:focus-within {
        --tw-text-opacity: 1;
        color: rgb(247 148 30 / var(--tw-text-opacity));
}

    .hover\\:\\!scale-100:hover {
        --tw-scale-x: 1 !important;
        --tw-scale-y: 1 !important;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

    .hover\\:\\!scale-\\[1\\.01\\]:hover {
        --tw-scale-x: 1.01 !important;
        --tw-scale-y: 1.01 !important;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

    .hover\\:transform:hover {
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

    .hover\\:cursor-pointer:hover {
        cursor: pointer;
}

    .hover\\:rounded-\\[8px\\]:hover {
        border-radius: 8px;
}

    .hover\\:bg-\\[\\#FFFFFF33\\]:hover {
        background-color: #FFFFFF33;
}

    .hover\\:bg-primary-navyblue-bright:hover {
        --tw-bg-opacity: 1;
        background-color: rgb(102 96 185 / var(--tw-bg-opacity));
}

    .hover\\:bg-primary-navyblue-shade\\/\\[0\\.65\\]:hover {
        background-color: rgb(62 58 110 / 0.65);
}

    .hover\\:bg-primary-skyblue-light:hover {
        --tw-bg-opacity: 1;
        background-color: rgb(200 235 250 / var(--tw-bg-opacity));
}

    .hover\\:text-alert-error:hover {
        --tw-text-opacity: 1;
        color: rgb(247 119 103 / var(--tw-text-opacity));
}

    .hover\\:text-primary-skyblue:hover {
        --tw-text-opacity: 1;
        color: rgb(39 170 225 / var(--tw-text-opacity));
}

    .mock-exam-layout .hover\\:forgot-back-hover:hover svg {
        fill: currentColor;
        --tw-text-opacity: 1 !important;
        color: rgb(39 170 225 / var(--tw-text-opacity)) !important;
}

    .mock-exam-layout .hover\\:forgot-back-hover:hover a {
        --tw-text-opacity: 1;
        color: rgb(39 170 225 / var(--tw-text-opacity));
}

    .focus-visible\\:outline-primary-apricot:focus-visible {
        outline-color: #F7941E;
}

    .active\\:bg-primary-skyblue:active {
        --tw-bg-opacity: 1;
        background-color: rgb(39 170 225 / var(--tw-bg-opacity));
}

    @media not all and (min-width: 1280px) {
        .max-xl\\:hidden {
                display: none;
        }
        .max-xl\\:\\!px-5 {
                padding-left: 1.25rem !important;
                padding-right: 1.25rem !important;
        }
}

    @media not all and (min-width: 1024px) {
        .max-lg\\:relative {
                position: relative;
        }
        .max-lg\\:-left-10 {
                left: -2.5rem;
        }
        .max-lg\\:bottom-12 {
                bottom: 3rem;
        }
        .max-lg\\:bottom-\\[-35rem\\] {
                bottom: -35rem;
        }
        .max-lg\\:bottom-\\[50px\\] {
                bottom: 50px;
        }
        .max-lg\\:left-1\\/2 {
                left: 50%;
        }
        .max-lg\\:left-\\[-35rem\\] {
                left: -35rem;
        }
        .max-lg\\:z-0 {
                z-index: 0;
        }
        .max-lg\\:z-10 {
                z-index: 10;
        }
        .max-lg\\:mx-auto {
                margin-left: auto;
                margin-right: auto;
        }
        .max-lg\\:my-\\[24px\\] {
                margin-top: 24px;
                margin-bottom: 24px;
        }
        .max-lg\\:my-auto {
                margin-top: auto;
                margin-bottom: auto;
        }
        .max-lg\\:mb-1 {
                margin-bottom: 0.25rem;
        }
        .max-lg\\:mb-4 {
                margin-bottom: 1rem;
        }
        .max-lg\\:mb-6 {
                margin-bottom: 1.5rem;
        }
        .max-lg\\:mb-8 {
                margin-bottom: 2rem;
        }
        .max-lg\\:ml-\\[106px\\] {
                margin-left: 106px;
        }
        .max-lg\\:ml-\\[14px\\] {
                margin-left: 14px;
        }
        .max-lg\\:ml-auto {
                margin-left: auto;
        }
        .max-lg\\:mt-0 {
                margin-top: 0px;
        }
        .max-lg\\:mt-4 {
                margin-top: 1rem;
        }
        .max-lg\\:mt-6 {
                margin-top: 1.5rem;
        }
        .max-lg\\:mt-\\[32px\\] {
                margin-top: 32px;
        }
        .max-lg\\:block {
                display: block;
        }
        .max-lg\\:flex {
                display: flex;
        }
        .max-lg\\:\\!hidden {
                display: none !important;
        }
        .max-lg\\:hidden {
                display: none;
        }
        .max-lg\\:\\!h-\\[46px\\] {
                height: 46px !important;
        }
        .max-lg\\:h-\\[140px\\] {
                height: 140px;
        }
        .max-lg\\:h-\\[232px\\] {
                height: 232px;
        }
        .max-lg\\:h-\\[242px\\] {
                height: 242px;
        }
        .max-lg\\:h-\\[70px\\] {
                height: 70px;
        }
        .max-lg\\:h-\\[78px\\] {
                height: 78px;
        }
        .max-lg\\:h-\\[80px\\] {
                height: 80px;
        }
        .max-lg\\:h-\\[calc\\(100svh-124px\\)\\] {
                height: calc(100svh - 124px);
        }
        .max-lg\\:h-\\[calc\\(100svh-131px\\)\\] {
                height: calc(100svh - 131px);
        }
        .max-lg\\:h-\\[calc\\(100svh-136px\\)\\] {
                height: calc(100svh - 136px);
        }
        .max-lg\\:h-\\[calc\\(100vh-110px\\)\\] {
                height: calc(100vh - 110px);
        }
        .max-lg\\:h-fit {
                height: -moz-fit-content;
                height: fit-content;
        }
        .max-lg\\:max-h-\\[94px\\] {
                max-height: 94px;
        }
        .max-lg\\:max-h-\\[calc\\(100vh-187px\\)\\] {
                max-height: calc(100vh - 187px);
        }
        .max-lg\\:\\!w-2\\/6 {
                width: 33.333333% !important;
        }
        .max-lg\\:\\!w-full {
                width: 100% !important;
        }
        .max-lg\\:w-11\\/12 {
                width: 91.666667%;
        }
        .max-lg\\:w-\\[18px\\] {
                width: 18px;
        }
        .max-lg\\:w-\\[200px\\] {
                width: 200px;
        }
        .max-lg\\:w-\\[22px\\] {
                width: 22px;
        }
        .max-lg\\:w-\\[236px\\] {
                width: 236px;
        }
        .max-lg\\:w-\\[331px\\] {
                width: 331px;
        }
        .max-lg\\:w-\\[377px\\] {
                width: 377px;
        }
        .max-lg\\:w-\\[539px\\] {
                width: 539px;
        }
        .max-lg\\:w-\\[calc\\(100\\%\\*347\\/744\\)\\] {
                width: calc(100% * 347 / 744);
        }
        .max-lg\\:w-full {
                width: 100%;
        }
        .max-lg\\:\\!max-w-full {
                max-width: 100% !important;
        }
        .max-lg\\:max-w-\\[350px\\] {
                max-width: 350px;
        }
        .max-lg\\:max-w-\\[371px\\] {
                max-width: 371px;
        }
        .max-lg\\:max-w-\\[456px\\] {
                max-width: 456px;
        }
        .max-lg\\:max-w-\\[619px\\] {
                max-width: 619px;
        }
        .max-lg\\:max-w-\\[calc\\(100vw-56px-86px\\)\\] {
                max-width: calc(100vw - 56px - 86px);
        }
        .max-lg\\:max-w-\\[none\\] {
                max-width: none;
        }
        .max-lg\\:max-w-full {
                max-width: 100%;
        }
        .max-lg\\:-translate-x-1\\/2 {
                --tw-translate-x: -50%;
                transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
        }
        .max-lg\\:flex-row {
                flex-direction: row;
        }
        .max-lg\\:flex-col {
                flex-direction: column;
        }
        .max-lg\\:items-start {
                align-items: flex-start;
        }
        .max-lg\\:justify-center {
                justify-content: center;
        }
        .max-lg\\:gap-4 {
                gap: 1rem;
        }
        .max-lg\\:self-end {
                align-self: flex-end;
        }
        .max-lg\\:bg-\\[center_top_5rem\\] {
                background-position: center top 5rem;
        }
        .max-lg\\:p-3 {
                padding: 0.75rem;
        }
        .max-lg\\:\\!px-4 {
                padding-left: 1rem !important;
                padding-right: 1rem !important;
        }
        .max-lg\\:px-16 {
                padding-left: 4rem;
                padding-right: 4rem;
        }
        .max-lg\\:px-3 {
                padding-left: 0.75rem;
                padding-right: 0.75rem;
        }
        .max-lg\\:py-2 {
                padding-top: 0.5rem;
                padding-bottom: 0.5rem;
        }
        .max-lg\\:py-\\[40px\\] {
                padding-top: 40px;
                padding-bottom: 40px;
        }
        .max-lg\\:pb-24 {
                padding-bottom: 6rem;
        }
        .max-lg\\:pb-4 {
                padding-bottom: 1rem;
        }
        .max-lg\\:pb-5 {
                padding-bottom: 1.25rem;
        }
        .max-lg\\:pb-6 {
                padding-bottom: 1.5rem;
        }
        .max-lg\\:pb-\\[56px\\] {
                padding-bottom: 56px;
        }
        .max-lg\\:pl-6 {
                padding-left: 1.5rem;
        }
        .max-lg\\:pl-\\[110px\\] {
                padding-left: 110px;
        }
        .max-lg\\:pl-\\[23px\\] {
                padding-left: 23px;
        }
        .max-lg\\:pr-6 {
                padding-right: 1.5rem;
        }
        .max-lg\\:pr-\\[110px\\] {
                padding-right: 110px;
        }
        .max-lg\\:pt-2 {
                padding-top: 0.5rem;
        }
        .max-lg\\:pt-6 {
                padding-top: 1.5rem;
        }
        .max-lg\\:\\!text-sm {
                font-size: 14px !important;
        }
        .max-lg\\:text-lg {
                font-size: 20px;
        }
        .max-lg\\:text-md {
                font-size: 16px;
        }
        .max-lg\\:text-sm {
                font-size: 14px;
        }
        .max-lg\\:text-xs {
                font-size: 12px;
        }
        .max-lg\\:font-semibold {
                font-weight: 600;
        }
        .max-lg\\:\\!leading-4 {
                line-height: 1rem !important;
        }
        .max-lg\\:\\!leading-\\[19px\\] {
                line-height: 19px !important;
        }
        .max-lg\\:leading-4 {
                line-height: 1rem;
        }
        .max-lg\\:text-neutral-whiteboard {
                --tw-text-opacity: 1;
                color: rgb(250 251 253 / var(--tw-text-opacity));
        }

    .webinar-snackbar > div > .max-lg\\:\\!max-w-full {
                display: flex;
        }

    .webinar-snackbar > div > .max-lg\\:max-w-full {
                display: flex;
        }

    .webinar-snackbar > div > .max-lg\\:\\!max-w-full {
                display: flex;
        }

    .webinar-snackbar > div > .max-lg\\:\\!max-w-full > .float-left {
                padding-right: 2rem;
        }

    @media not all and (min-width: 640px) {
                .webinar-snackbar > div > .max-lg\\:\\!max-w-full > .float-left {
                        padding-right: 1rem;
                }
        }

    .webinar-snackbar > div > .max-lg\\:max-w-full {
                display: flex;
        }

    .webinar-snackbar > div > .max-lg\\:max-w-full > .float-left {
                padding-right: 2rem;
        }

    @media not all and (min-width: 640px) {
                .webinar-snackbar > div > .max-lg\\:max-w-full > .float-left {
                        padding-right: 1rem;
                }
        }

    .webinar-snackbar > div > .max-lg\\:\\!max-w-full {
                display: flex;
        }

    .webinar-snackbar > div > .max-lg\\:\\!max-w-full > .float-left {
                padding-right: 2rem;
        }

    @media not all and (min-width: 640px) {
                .webinar-snackbar > div > .max-lg\\:\\!max-w-full > .float-left {
                        padding-right: 1rem;
                }
        }

     .webinar-snackbar > div > .max-lg\\:\\!max-w-full > .float-right {
                display: flex;
                align-items: center;
        }

    .webinar-snackbar > div > .max-lg\\:max-w-full {
                display: flex;
        }

    .webinar-snackbar > div > .max-lg\\:max-w-full > .float-left {
                padding-right: 2rem;
        }

    @media not all and (min-width: 640px) {
                .webinar-snackbar > div > .max-lg\\:max-w-full > .float-left {
                        padding-right: 1rem;
                }
        }

     .webinar-snackbar > div > .max-lg\\:max-w-full > .float-right {
                display: flex;
                align-items: center;
        }

    .before\\:max-lg\\:top-12::before {
                content: var(--tw-content);
                top: 3rem;
        }

    .max-lg\\:hover\\:\\!scale-\\[1\\.01\\]:hover {
                --tw-scale-x: 1.01 !important;
                --tw-scale-y: 1.01 !important;
                transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
        }
}

    @media not all and (min-width: 743px) {
        .max-md\\:absolute {
                position: absolute;
        }
        .max-md\\:relative {
                position: relative;
        }
        .max-md\\:-left-6 {
                left: -1.5rem;
        }
        .max-md\\:bottom-\\[70px\\] {
                bottom: 70px;
        }
        .max-md\\:left-1\\/2 {
                left: 50%;
        }
        .max-md\\:right-0 {
                right: 0px;
        }
        .max-md\\:top-1\\/2 {
                top: 50%;
        }
        .max-md\\:col-span-2 {
                grid-column: span 2 / span 2;
        }
        .max-md\\:float-left {
                float: left;
        }
        .max-md\\:mx-auto {
                margin-left: auto;
                margin-right: auto;
        }
        .max-md\\:\\!mb-0 {
                margin-bottom: 0px !important;
        }
        .max-md\\:-ml-2 {
                margin-left: -0.5rem;
        }
        .max-md\\:mb-1 {
                margin-bottom: 0.25rem;
        }
        .max-md\\:mb-1\\.5 {
                margin-bottom: 0.375rem;
        }
        .max-md\\:mb-2 {
                margin-bottom: 0.5rem;
        }
        .max-md\\:mr-2 {
                margin-right: 0.5rem;
        }
        .max-md\\:mt-0 {
                margin-top: 0px;
        }
        .max-md\\:mt-1 {
                margin-top: 0.25rem;
        }
        .max-md\\:block {
                display: block;
        }
        .max-md\\:inline-block {
                display: inline-block;
        }
        .max-md\\:flex {
                display: flex;
        }
        .max-md\\:inline-flex {
                display: inline-flex;
        }
        .max-md\\:hidden {
                display: none;
        }
        .max-md\\:\\!h-4 {
                height: 1rem !important;
        }
        .max-md\\:\\!h-8 {
                height: 2rem !important;
        }
        .max-md\\:\\!h-\\[34px\\] {
                height: 34px !important;
        }
        .max-md\\:h-10 {
                height: 2.5rem;
        }
        .max-md\\:h-6 {
                height: 1.5rem;
        }
        .max-md\\:h-\\[520px\\] {
                height: 520px;
        }
        .max-md\\:h-\\[60px\\] {
                height: 60px;
        }
        .max-md\\:h-\\[90vh\\] {
                height: 90vh;
        }
        .max-md\\:h-\\[calc\\(100svh-109px\\)\\] {
                height: calc(100svh - 109px);
        }
        .max-md\\:h-\\[calc\\(100svh-116px\\)\\] {
                height: calc(100svh - 116px);
        }
        .max-md\\:h-\\[calc\\(100svh-92px\\)\\] {
                height: calc(100svh - 92px);
        }
        .max-md\\:h-\\[calc\\(100vh-100px\\)\\] {
                height: calc(100vh - 100px);
        }
        .max-md\\:h-full {
                height: 100%;
        }
        .max-md\\:max-h-\\[calc\\(100\\%-48px\\)\\] {
                max-height: calc(100% - 48px);
        }
        .max-md\\:\\!w-\\[17\\.5px\\] {
                width: 17.5px !important;
        }
        .max-md\\:\\!w-full {
                width: 100% !important;
        }
        .max-md\\:w-16 {
                width: 4rem;
        }
        .max-md\\:w-\\[175px\\] {
                width: 175px;
        }
        .max-md\\:w-\\[264px\\] {
                width: 264px;
        }
        .max-md\\:w-\\[326px\\] {
                width: 326px;
        }
        .max-md\\:w-\\[32px\\] {
                width: 32px;
        }
        .max-md\\:w-\\[calc\\(100\\%\\*266\\/375\\)\\] {
                width: calc(100% * 266 / 375);
        }
        .max-md\\:w-full {
                width: 100%;
        }
        .max-md\\:w-screen {
                width: 100vw;
        }
        .max-md\\:\\!max-w-full {
                max-width: 100% !important;
        }
        .max-md\\:max-w-full {
                max-width: 100%;
        }
        .max-md\\:-translate-x-1\\/2 {
                --tw-translate-x: -50%;
                transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
        }
        .max-md\\:-translate-y-1\\/2 {
                --tw-translate-y: -50%;
                transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
        }
        .max-md\\:grid-cols-3 {
                grid-template-columns: repeat(3, minmax(0, 1fr));
        }
        .max-md\\:flex-col {
                flex-direction: column;
        }
        .max-md\\:items-start {
                align-items: flex-start;
        }
        .max-md\\:items-center {
                align-items: center;
        }
        .max-md\\:justify-center {
                justify-content: center;
        }
        .max-md\\:bg-primary-navyblue {
                --tw-bg-opacity: 1;
                background-color: rgb(38 34 98 / var(--tw-bg-opacity));
        }
        .max-md\\:bg-center {
                background-position: center;
        }
        .max-md\\:fill-primary-apricot {
                fill: #F7941E;
        }
        .max-md\\:\\!p-8 {
                padding: 2rem !important;
        }
        .max-md\\:p-2 {
                padding: 0.5rem;
        }
        .max-md\\:p-3 {
                padding: 0.75rem;
        }
        .max-md\\:p-4 {
                padding: 1rem;
        }
        .max-md\\:p-6 {
                padding: 1.5rem;
        }
        .max-md\\:\\!px-\\[0px\\] {
                padding-left: 0px !important;
                padding-right: 0px !important;
        }
        .max-md\\:\\!py-1 {
                padding-top: 0.25rem !important;
                padding-bottom: 0.25rem !important;
        }
        .max-md\\:px-4 {
                padding-left: 1rem;
                padding-right: 1rem;
        }
        .max-md\\:px-\\[17px\\] {
                padding-left: 17px;
                padding-right: 17px;
        }
        .max-md\\:py-5 {
                padding-top: 1.25rem;
                padding-bottom: 1.25rem;
        }
        .max-md\\:py-6 {
                padding-top: 1.5rem;
                padding-bottom: 1.5rem;
        }
        .max-md\\:\\!pl-0 {
                padding-left: 0px !important;
        }
        .max-md\\:\\!pr-4 {
                padding-right: 1rem !important;
        }
        .max-md\\:pb-2 {
                padding-bottom: 0.5rem;
        }
        .max-md\\:pb-2\\.5 {
                padding-bottom: 0.625rem;
        }
        .max-md\\:pb-4 {
                padding-bottom: 1rem;
        }
        .max-md\\:pb-\\[84px\\] {
                padding-bottom: 84px;
        }
        .max-md\\:pl-2 {
                padding-left: 0.5rem;
        }
        .max-md\\:pt-2 {
                padding-top: 0.5rem;
        }
        .max-md\\:pt-\\[16px\\] {
                padding-top: 16px;
        }
        .max-md\\:pt-\\[4px\\] {
                padding-top: 4px;
        }
        .max-md\\:\\!text-md {
                font-size: 16px !important;
        }
        .max-md\\:text-\\[12px\\] {
                font-size: 12px;
        }
        .max-md\\:text-md {
                font-size: 16px;
        }
        .max-md\\:text-xl {
                font-size: 24px;
        }
        .max-md\\:text-xs {
                font-size: 12px;
        }
        .max-md\\:leading-3 {
                line-height: .75rem;
        }
        .max-md\\:leading-6 {
                line-height: 1.5rem;
        }
        .max-md\\:leading-8 {
                line-height: 2rem;
        }
        .max-md\\:text-neutral-whiteboard {
                --tw-text-opacity: 1;
                color: rgb(250 251 253 / var(--tw-text-opacity));
        }

    .webinar-snackbar > div > .max-md\\:\\!max-w-full {
                display: flex;
        }

    .webinar-snackbar > div > .max-md\\:max-w-full {
                display: flex;
        }

    .webinar-snackbar > div > .max-md\\:\\!max-w-full {
                display: flex;
        }

    .webinar-snackbar > div > .max-md\\:\\!max-w-full > .float-left {
                padding-right: 2rem;
        }

    @media not all and (min-width: 640px) {
                .webinar-snackbar > div > .max-md\\:\\!max-w-full > .float-left {
                        padding-right: 1rem;
                }
        }

    .webinar-snackbar > div > .max-md\\:max-w-full {
                display: flex;
        }

    .webinar-snackbar > div > .max-md\\:max-w-full > .float-left {
                padding-right: 2rem;
        }

    @media not all and (min-width: 640px) {
                .webinar-snackbar > div > .max-md\\:max-w-full > .float-left {
                        padding-right: 1rem;
                }
        }

    .max-md\\:float-left {
                float: left;
        }

    .webinar-snackbar > div > .max-w-full > .max-md\\:float-left {
                padding-right: 2rem;
        }

    @media not all and (min-width: 640px) {
                .webinar-snackbar > div > .max-w-full > .max-md\\:float-left {
                        padding-right: 1rem;
                }
        }

    .webinar-snackbar > div > .max-md\\:\\!max-w-full {
                display: flex;
        }

    .webinar-snackbar > div > .max-md\\:\\!max-w-full > .float-left {
                padding-right: 2rem;
        }

    @media not all and (min-width: 640px) {
                .webinar-snackbar > div > .max-md\\:\\!max-w-full > .float-left {
                        padding-right: 1rem;
                }
        }

     .webinar-snackbar > div > .max-md\\:\\!max-w-full > .float-right {
                display: flex;
                align-items: center;
        }

    .webinar-snackbar > div > .max-md\\:max-w-full {
                display: flex;
        }

    .webinar-snackbar > div > .max-md\\:max-w-full > .float-left {
                padding-right: 2rem;
        }

    @media not all and (min-width: 640px) {
                .webinar-snackbar > div > .max-md\\:max-w-full > .float-left {
                        padding-right: 1rem;
                }
        }

     .webinar-snackbar > div > .max-md\\:max-w-full > .float-right {
                display: flex;
                align-items: center;
        }

    .before\\:max-md\\:h-\\[calc\\(100\\%\\+68px\\)\\]::before {
                content: var(--tw-content);
                height: calc(100% + 68px);
        }
}

    @media not all and (min-width: 640px) {
        .max-sm\\:bottom-\\[-40rem\\] {
                bottom: -40rem;
        }
        .max-sm\\:left-\\[-40rem\\] {
                left: -40rem;
        }
        .max-sm\\:my-\\[16px\\] {
                margin-top: 16px;
                margin-bottom: 16px;
        }
        .max-sm\\:\\!mb-1 {
                margin-bottom: 0.25rem !important;
        }
        .max-sm\\:\\!mb-4 {
                margin-bottom: 1rem !important;
        }
        .max-sm\\:\\!ml-0 {
                margin-left: 0px !important;
        }
        .max-sm\\:ml-\\[50px\\] {
                margin-left: 50px;
        }
        .max-sm\\:block {
                display: block;
        }
        .max-sm\\:hidden {
                display: none;
        }
        .max-sm\\:h-\\[101px\\] {
                height: 101px;
        }
        .max-sm\\:h-\\[133px\\] {
                height: 133px;
        }
        .max-sm\\:h-\\[170px\\] {
                height: 170px;
        }
        .max-sm\\:h-\\[183px\\] {
                height: 183px;
        }
        .max-sm\\:h-\\[44px\\] {
                height: 44px;
        }
        .max-sm\\:h-\\[84px\\] {
                height: 84px;
        }
        .max-sm\\:h-\\[calc\\(100vh-390px\\)\\] {
                height: calc(100vh - 390px);
        }
        .max-sm\\:h-\\[calc\\(100vh-450px\\)\\] {
                height: calc(100vh - 450px);
        }
        .max-sm\\:max-h-\\[250px\\] {
                max-height: 250px;
        }
        .max-sm\\:\\!w-full {
                width: 100% !important;
        }
        .max-sm\\:w-1\\/2 {
                width: 50%;
        }
        .max-sm\\:w-\\[12\\%\\] {
                width: 12%;
        }
        .max-sm\\:w-\\[134px\\] {
                width: 134px;
        }
        .max-sm\\:w-\\[15\\%\\] {
                width: 15%;
        }
        .max-sm\\:w-\\[150px\\] {
                width: 150px;
        }
        .max-sm\\:w-\\[18\\%\\] {
                width: 18%;
        }
        .max-sm\\:w-\\[180px\\] {
                width: 180px;
        }
        .max-sm\\:w-\\[20\\%\\] {
                width: 20%;
        }
        .max-sm\\:w-\\[210px\\] {
                width: 210px;
        }
        .max-sm\\:w-\\[224px\\] {
                width: 224px;
        }
        .max-sm\\:w-\\[25\\%\\] {
                width: 25%;
        }
        .max-sm\\:w-\\[296px\\] {
                width: 296px;
        }
        .max-sm\\:w-\\[5\\%\\] {
                width: 5%;
        }
        .max-sm\\:w-\\[6\\%\\] {
                width: 6%;
        }
        .max-sm\\:w-full {
                width: 100%;
        }
        .max-sm\\:\\!max-w-none {
                max-width: none !important;
        }
        .max-sm\\:max-w-\\[344px\\] {
                max-width: 344px;
        }
        .max-sm\\:max-w-full {
                max-width: 100%;
        }
        .max-sm\\:flex-col {
                flex-direction: column;
        }
        .max-sm\\:justify-center {
                justify-content: center;
        }
        .max-sm\\:gap-6 {
                gap: 1.5rem;
        }
        .max-sm\\:rounded-\\[29px\\] {
                border-radius: 29px;
        }
        .max-sm\\:bg-\\[center_top_10rem\\] {
                background-position: center top 10rem;
        }
        .max-sm\\:px-4 {
                padding-left: 1rem;
                padding-right: 1rem;
        }
        .max-sm\\:px-\\[24px\\] {
                padding-left: 24px;
                padding-right: 24px;
        }
        .max-sm\\:\\!pl-6 {
                padding-left: 1.5rem !important;
        }
        .max-sm\\:\\!pl-7 {
                padding-left: 1.75rem !important;
        }
        .max-sm\\:pl-\\[15px\\] {
                padding-left: 15px;
        }
        .max-sm\\:pr-\\[15px\\] {
                padding-right: 15px;
        }
        .max-sm\\:text-\\[10px\\] {
                font-size: 10px;
        }
        .max-sm\\:text-\\[14px\\] {
                font-size: 14px;
        }
        .max-sm\\:text-\\[16px\\] {
                font-size: 16px;
        }
        .max-sm\\:text-\\[24px\\] {
                font-size: 24px;
        }
        .max-sm\\:text-md {
                font-size: 16px;
        }
        .max-sm\\:text-sm {
                font-size: 14px;
        }
        .max-sm\\:text-xs {
                font-size: 12px;
        }
        .max-sm\\:leading-\\[21px\\] {
                line-height: 21px;
        }
        .max-sm\\:shadow-\\[0px_9px_0px_0px_\\#282661\\] {
                --tw-shadow: 0px 9px 0px 0px #282661;
                --tw-shadow-colored: 0px 9px 0px 0px var(--tw-shadow-color);
                box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
        }

    .webinar-snackbar > div > .max-sm\\:max-w-full {
                display: flex;
        }

    .webinar-snackbar > div > .max-sm\\:max-w-full > .float-left {
                padding-right: 2rem;
        }

    @media not all and (min-width: 640px) {
                .webinar-snackbar > div > .max-sm\\:max-w-full > .float-left {
                        padding-right: 1rem;
                }
        }

    .webinar-snackbar > div > .max-sm\\:max-w-full {
                display: flex;
        }

    .webinar-snackbar > div > .max-sm\\:max-w-full > .float-left {
                padding-right: 2rem;
        }

    @media not all and (min-width: 640px) {
                .webinar-snackbar > div > .max-sm\\:max-w-full > .float-left {
                        padding-right: 1rem;
                }
        }

     .webinar-snackbar > div > .max-sm\\:max-w-full > .float-right {
                display: flex;
                align-items: center;
        }
}

    @media (max-width: 400px) {
        .max-\\[400px\\]\\:-mb-\\[19px\\] {
                margin-bottom: -19px;
        }
        .max-\\[400px\\]\\:max-w-\\[240px\\] {
                max-width: 240px;
        }
}

    @media (max-width: 300px) {
        .max-\\[300px\\]\\:hidden {
                display: none;
        }
}

    @media (min-width: 640px) {
        .sm\\:hidden {
                display: none;
        }
        .sm\\:w-1\\/3 {
                width: 33.333333%;
        }
        .sm\\:w-2\\/3 {
                width: 66.666667%;
        }
}

    @media (min-width: 743px) {
        .md\\:col-span-1 {
                grid-column: span 1 / span 1;
        }
        .md\\:mb-0 {
                margin-bottom: 0px;
        }
        .md\\:ml-\\[14px\\] {
                margin-left: 14px;
        }
        .md\\:mr-16 {
                margin-right: 4rem;
        }
        .md\\:mr-2 {
                margin-right: 0.5rem;
        }
        .md\\:mr-4 {
                margin-right: 1rem;
        }
        .md\\:mr-8 {
                margin-right: 2rem;
        }
        .md\\:mr-\\[16px\\] {
                margin-right: 16px;
        }
        .md\\:mt-\\[19px\\] {
                margin-top: 19px;
        }
        .md\\:inline {
                display: inline;
        }
        .md\\:flex {
                display: flex;
        }
        .md\\:inline-flex {
                display: inline-flex;
        }
        .md\\:hidden {
                display: none;
        }
        .md\\:h-\\[550px\\] {
                height: 550px;
        }
        .md\\:h-\\[56px\\] {
                height: 56px;
        }
        .md\\:h-\\[70vh\\] {
                height: 70vh;
        }
        .md\\:max-h-\\[104px\\] {
                max-height: 104px;
        }
        .md\\:max-h-\\[97px\\] {
                max-height: 97px;
        }
        .md\\:max-h-full {
                max-height: 100%;
        }
        .md\\:w-1\\/2 {
                width: 50%;
        }
        .md\\:w-\\[24px\\] {
                width: 24px;
        }
        .md\\:w-\\[368px\\] {
                width: 368px;
        }
        .md\\:w-\\[66\\%\\] {
                width: 66%;
        }
        .md\\:w-auto {
                width: auto;
        }
        .md\\:max-w-\\[352px\\] {
                max-width: 352px;
        }
        .md\\:grid-cols-4 {
                grid-template-columns: repeat(4, minmax(0, 1fr));
        }
        .md\\:flex-row {
                flex-direction: row;
        }
        .md\\:flex-wrap {
                flex-wrap: wrap;
        }
        .md\\:content-center {
                align-content: center;
        }
        .md\\:items-center {
                align-items: center;
        }
        .md\\:justify-end {
                justify-content: flex-end;
        }
        .md\\:px-6 {
                padding-left: 1.5rem;
                padding-right: 1.5rem;
        }
        .md\\:px-\\[24px\\] {
                padding-left: 24px;
                padding-right: 24px;
        }
        .md\\:px-\\[65px\\] {
                padding-left: 65px;
                padding-right: 65px;
        }
        .md\\:py-3 {
                padding-top: 0.75rem;
                padding-bottom: 0.75rem;
        }
        .md\\:py-8 {
                padding-top: 2rem;
                padding-bottom: 2rem;
        }
        .md\\:pt-8 {
                padding-top: 2rem;
        }
        .md\\:text-lg {
                font-size: 20px;
        }
        .md\\:text-md {
                font-size: 16px;
        }
        .md\\:text-sm {
                font-size: 14px;
        }
        .md\\:leading-3 {
                line-height: .75rem;
        }
        .md\\:leading-3\\.5 {
                line-height: 14px;
        }
        .md\\:text-primary-navyblue {
                --tw-text-opacity: 1;
                color: rgb(38 34 98 / var(--tw-text-opacity));
        }
        @media not all and (min-width: 1024px) {
                .md\\:max-lg\\:mb-4 {
                        margin-bottom: 1rem;
                }
                .md\\:max-lg\\:mt-4 {
                        margin-top: 1rem;
                }
        }
}

    @media not all and (min-width: 1024px) {
        @media (min-width: 743px) {
                .max-lg\\:md\\:\\!pl-12 {
                        padding-left: 3rem !important;
                }
                .max-lg\\:md\\:\\!pr-16 {
                        padding-right: 4rem !important;
                }
        }
}

    @media (min-width: 1024px) {
        .lg\\:fixed {
                position: fixed;
        }
        .lg\\:bottom-0 {
                bottom: 0px;
        }
        .lg\\:bottom-7 {
                bottom: 1.75rem;
        }
        .lg\\:left-0 {
                left: 0px;
        }
        .lg\\:left-\\[38px\\] {
                left: 38px;
        }
        .lg\\:z-0 {
                z-index: 0;
        }
        .lg\\:mx-6 {
                margin-left: 1.5rem;
                margin-right: 1.5rem;
        }
        .lg\\:mb-10 {
                margin-bottom: 2.5rem;
        }
        .lg\\:mb-2 {
                margin-bottom: 0.5rem;
        }
        .lg\\:mb-4 {
                margin-bottom: 1rem;
        }
        .lg\\:mb-6 {
                margin-bottom: 1.5rem;
        }
        .lg\\:mb-8 {
                margin-bottom: 2rem;
        }
        .lg\\:mb-\\[16px\\] {
                margin-bottom: 16px;
        }
        .lg\\:ml-6 {
                margin-left: 1.5rem;
        }
        .lg\\:ml-\\[30px\\] {
                margin-left: 30px;
        }
        .lg\\:ml-auto {
                margin-left: auto;
        }
        .lg\\:mr-\\[27px\\] {
                margin-right: 27px;
        }
        .lg\\:mt-\\[-70px\\] {
                margin-top: -70px;
        }
        .lg\\:flex {
                display: flex;
        }
        .lg\\:\\!hidden {
                display: none !important;
        }
        .lg\\:hidden {
                display: none;
        }
        .lg\\:\\!h-\\[34px\\] {
                height: 34px !important;
        }
        .lg\\:h-\\[100px\\] {
                height: 100px;
        }
        .lg\\:h-\\[16px\\] {
                height: 16px;
        }
        .lg\\:h-\\[88px\\] {
                height: 88px;
        }
        .lg\\:h-\\[calc\\(100vh-700px\\)\\] {
                height: calc(100vh - 700px);
        }
        .lg\\:h-\\[calc\\(100vh-96px\\)\\] {
                height: calc(100vh - 96px);
        }
        .lg\\:max-h-\\[116px\\] {
                max-height: 116px;
        }
        .lg\\:max-h-\\[123px\\] {
                max-height: 123px;
        }
        .lg\\:max-h-\\[143px\\] {
                max-height: 143px;
        }
        .lg\\:\\!w-full {
                width: 100% !important;
        }
        .lg\\:w-3\\/12 {
                width: 25%;
        }
        .lg\\:w-9\\/12 {
                width: 75%;
        }
        .lg\\:w-\\[340px\\] {
                width: 340px;
        }
        .lg\\:w-\\[400px\\] {
                width: 400px;
        }
        .lg\\:min-w-\\[343px\\] {
                min-width: 343px;
        }
        .lg\\:min-w-\\[536px\\] {
                min-width: 536px;
        }
        .lg\\:max-w-\\[340px\\] {
                max-width: 340px;
        }
        .lg\\:max-w-\\[417px\\] {
                max-width: 417px;
        }
        .lg\\:flex-col {
                flex-direction: column;
        }
        .lg\\:flex-wrap {
                flex-wrap: wrap;
        }
        .lg\\:justify-center {
                justify-content: center;
        }
        .lg\\:gap-4 {
                gap: 1rem;
        }
        .lg\\:gap-6 {
                gap: 1.5rem;
        }
        .lg\\:overflow-y-auto {
                overflow-y: auto;
        }
        .lg\\:bg-neutral-whiteboard {
                --tw-bg-opacity: 1;
                background-color: rgb(250 251 253 / var(--tw-bg-opacity));
        }
        .lg\\:p-4 {
                padding: 1rem;
        }
        .lg\\:px-5 {
                padding-left: 1.25rem;
                padding-right: 1.25rem;
        }
        .lg\\:px-\\[8\\.33\\%\\] {
                padding-left: 8.33%;
                padding-right: 8.33%;
        }
        .lg\\:py-4 {
                padding-top: 1rem;
                padding-bottom: 1rem;
        }
        .lg\\:pb-0 {
                padding-bottom: 0px;
        }
        .lg\\:pb-6 {
                padding-bottom: 1.5rem;
        }
        .lg\\:pt-10 {
                padding-top: 2.5rem;
        }
        .lg\\:text-md {
                font-size: 16px;
        }
        .lg\\:text-sm {
                font-size: 14px;
        }
        .lg\\:text-xl {
                font-size: 24px;
        }
        .lg\\:font-bold {
                font-weight: 700;
        }
        .lg\\:\\!leading-\\[19px\\] {
                line-height: 19px !important;
        }
        .lg\\:\\!leading-\\[22px\\] {
                line-height: 22px !important;
        }
        .lg\\:leading-\\[19px\\] {
                line-height: 19px;
        }
        .lg\\:leading-\\[22px\\] {
                line-height: 22px;
        }
        .lg\\:text-primary-navyblue {
                --tw-text-opacity: 1;
                color: rgb(38 34 98 / var(--tw-text-opacity));
        }
}

    .\\[\\&\\>\\.account-menu-group\\>\\.account-menu-item-container\\>a\\>div\\.account-menu-item\\]\\:\\!ml-0>.account-menu-group>.account-menu-item-container>a>div.account-menu-item {
        margin-left: 0px !important;
}

    .\\[\\&\\>\\.account-menu-group\\>p\\]\\:\\!ml-4>.account-menu-group>p {
        margin-left: 1rem !important;
}

    .\\[\\&\\>div\\.carousel\\>div\\.flickity-viewport\\]\\:\\!h-\\[320px\\]>div.carousel>div.flickity-viewport {
        height: 320px !important;
}

    .\\[\\&\\>div\\.carousel\\]\\:\\!mb-5>div.carousel {
        margin-bottom: 1.25rem !important;
}

    .\\[\\&\\>div\\>\\.shadow-div\\]\\:h-\\[20px\\]>div>.shadow-div {
        height: 20px;
}

    .\\[\\&\\>div\\>input\\]\\:h-12>div>input {
        height: 3rem;
}

    .\\[\\&\\>div\\>input\\]\\:h-\\[48px\\]>div>input {
        height: 48px;
}

    .\\[\\&\\>div\\>input\\]\\:border-0>div>input {
        border-width: 0px;
}

    .\\[\\&\\>div\\>input\\]\\:bg-neutral-notebook\\/\\[0\\.5\\]>div>input {
        background-color: rgb(220 227 239 / 0.5);
}

    .\\[\\&\\>div\\]\\:flex>div {
        display: flex;
}

    .\\[\\&\\>div\\]\\:items-center>div {
        align-items: center;
}

    .\\[\\&\\>div\\]\\:justify-center>div {
        justify-content: center;
}

    .\\[\\&\\>input\\]\\:w-full>input {
        width: 100%;
}

    .\\[\\&\\>input\\]\\:\\!rounded-lg>input {
        border-radius: 0.5rem !important;
}

    .\\[\\&\\>input\\]\\:border-0>input {
        border-width: 0px;
}

    .\\[\\&\\>input\\]\\:bg-neutral-notebook\\/\\[0\\.5\\]>input {
        background-color: rgb(220 227 239 / 0.5);
}

    .\\[\\&\\>input\\]\\:\\!pr-16>input {
        padding-right: 4rem !important;
}

    .\\[\\&\\>label\\>div\\>svg\\]\\:\\!h-6>label>div>svg {
        height: 1.5rem !important;
}

    .\\[\\&\\>span\\:last-child\\]\\:block>span:last-child {
        display: block;
}

    .\\[\\&\\>span\\:last-child\\]\\:truncate>span:last-child {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
}

    .\\[\\&\\>span\\:last-child\\]\\:text-ellipsis>span:last-child {
        text-overflow: ellipsis;
}

    .\\[\\&\\>span\\]\\:\\!leading-4>span {
        line-height: 1rem !important;
}

    .\\[\\&\\>td\\]\\:py-2>td {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
}

    .\\[\\&\\>th\\]\\:bg-neutral-sketchbook>th {
        --tw-bg-opacity: 1;
        background-color: rgb(244 247 252 / var(--tw-bg-opacity));
}

    .\\[\\&\\>th\\]\\:py-2>th {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
}

    .\\[\\&_input\\]\\:h-12 input {
        height: 3rem;
}

    .\\[\\&_input\\]\\:\\!border input {
        border-width: 1px !important;
}

    .\\[\\&_input\\]\\:px-4 input {
        padding-left: 1rem;
        padding-right: 1rem;
}

    .\\[\\&_input\\]\\:py-3 input {
        padding-top: 0.75rem;
        padding-bottom: 0.75rem;
}

    .\\[\\&_p\\]\\:flex p {
        display: flex;
}

    .\\[\\&_p\\]\\:items-center p {
        align-items: center;
}

    .\\[\\&_p\\]\\:justify-start p {
        justify-content: flex-start;
}

    .\\[\\&_p\\]\\:text-neutral-whiteboard p {
        --tw-text-opacity: 1;
        color: rgb(250 251 253 / var(--tw-text-opacity));
}

    .\\[\\&_span\\]\\:ml-auto span {
        margin-left: auto;
}

    .\\[\\&_span\\]\\:pl-1 span {
        padding-left: 0.25rem;
}

    .\\[\\&_span\\]\\:font-bold span {
        font-weight: 700;
}

    .\\[\\&_span\\]\\:text-neutral-pencil span {
        --tw-text-opacity: 1;
        color: rgb(81 81 81 / var(--tw-text-opacity));
}

    .\\[\\&_svg\\:first-of-type\\]\\:hidden svg:first-of-type {
        display: none;
}

    .\\[\\&_svg\\]\\:h-\\[24px\\] svg {
        height: 24px;
}

    .\\[\\&_svg\\]\\:w-\\[21px\\] svg {
        width: 21px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/mock_exam/MockExamRegistration.css"],"names":[],"mappings":"AAAA;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,qBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,iBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,mBAAmB;QAAnB;AAAmB;AAAnB;QAAA,gBAAmB;QAAnB;AAAmB;AAAnB;QAAA,iBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,mBAAmB;QAAnB;AAAmB;AAAnB;QAAA,gBAAmB;QAAnB;AAAmB;AAAnB;QAAA,gBAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,gBAAmB;QAAnB,oBAAmB;QAAnB,4BAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,mCAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,wBAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,uBAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,uBAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,2BAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,sBAAmB;QAAnB;AAAmB;AAAnB;QAAA,uBAAmB;QAAnB;AAAmB;AAAnB;QAAA,sBAAmB;QAAnB;AAAmB;AAAnB;QAAA,qBAAmB;QAAnB;AAAmB;AAAnB;QAAA,sBAAmB;QAAnB;AAAmB;AAAnB;QAAA,mBAAmB;QAAnB;AAAmB;AAAnB;QAAA,mBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,iBAAmB;QAAnB,iBAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,qBAAmB;aAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,gBAAmB;QAAnB,uBAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,gCAAmB;QAAnB;AAAmB;AAAnB;QAAA,8BAAmB;QAAnB;AAAmB;AAAnB;QAAA,+BAAmB;QAAnB;AAAmB;AAAnB;QAAA,4BAAmB;QAAnB;AAAmB;AAAnB;QAAA,4BAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,qBAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,iCAAmB;QAAnB;AAAmB;AAAnB;QAAA,sBAAmB;QAAnB;AAAmB;AAAnB;QAAA,sBAAmB;QAAnB;AAAmB;AAAnB;QAAA,sBAAmB;QAAnB;AAAmB;AAAnB;QAAA,sBAAmB;QAAnB;AAAmB;AAAnB;QAAA,sBAAmB;QAAnB;AAAmB;AAAnB;QAAA,sBAAmB;QAAnB;AAAmB;AAAnB;QAAA,sBAAmB;QAAnB;AAAmB;AAAnB;QAAA,sBAAmB;QAAnB;AAAmB;AAAnB;QAAA,sBAAmB;QAAnB;AAAmB;AAAnB;QAAA,6BAAmB;QAAnB;AAAmB;AAAnB;QAAA,6BAAmB;QAAnB;AAAmB;AAAnB;QAAA,6BAAmB;QAAnB;AAAmB;AAAnB;QAAA,6BAAmB;QAAnB;AAAmB;AAAnB;QAAA,6BAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,4DAAmB;QAAnB,mEAAmB;QAAnB;AAAmB;AAAnB;QAAA,4DAAmB;QAAnB,mEAAmB;QAAnB;AAAmB;AAAnB;QAAA,4DAAmB;QAAnB,qEAAmB;QAAnB;AAAmB;AAAnB;QAAA,4DAAmB;QAAnB,qEAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,6BAAmB;gBAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,sBAAmB;WAAnB;AAAmB;AAAnB;QAAA,mBAAmB;WAAnB;AAAmB;AAAnB;QAAA,+BAAmB;WAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,4BAAmB;QAAnB;AAAmB;AAAnB;QAAA,+BAAmB;QAAnB;AAAmB;AAAnB;QAAA,6BAAmB;QAAnB;AAAmB;AAAnB;QAAA,+BAAmB;QAAnB;AAAmB;AAAnB;QAAA,6BAAmB;QAAnB;AAAmB;AAAnB;QAAA,6BAAmB;QAAnB;AAAmB;AAAnB;QAAA,2BAAmB;QAAnB;AAAmB;AAAnB;QAAA,8BAAmB;QAAnB;AAAmB;AAAnB;QAAA,8BAAmB;QAAnB;AAAmB;AAAnB;QAAA,4BAAmB;QAAnB;AAAmB;AAAnB;QAAA,qBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,qBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,qBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,kBAAmB;QAAnB;AAAmB;AAAnB;QAAA,gBAAmB;QAAnB;AAAmB;AAAnB;QAAA,qBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,mBAAmB;QAAnB;AAAmB;AAAnB;QAAA,qBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,qBAAmB;QAAnB;AAAmB;AAAnB;QAAA,iBAAmB;QAAnB;AAAmB;AAAnB;QAAA,mBAAmB;QAAnB;AAAmB;AAAnB;QAAA,iBAAmB;QAAnB;AAAmB;AAAnB;QAAA,iBAAmB;QAAnB;AAAmB;AAAnB;QAAA,iBAAmB;QAAnB;AAAmB;AAAnB;QAAA,gBAAmB;QAAnB;AAAmB;AAAnB;QAAA,iBAAmB;QAAnB;AAAmB;AAAnB;QAAA,gBAAmB;QAAnB;AAAmB;AAAnB;QAAA,iBAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,+BAAmB;QAAnB;AAAmB;AAAnB;QAAA,+BAAmB;QAAnB;AAAmB;AAAnB;QAAA,+BAAmB;QAAnB;AAAmB;AAAnB;QAAA,+BAAmB;QAAnB;AAAmB;AAAnB;QAAA,+BAAmB;QAAnB;AAAmB;AAAnB;QAAA,+BAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,mCAAmB;QAAnB,wDAAmB;QAAnB;AAAmB;AAAnB;QAAA,oDAAmB;QAAnB,4DAAmB;QAAnB;AAAmB;AAAnB;QAAA,qCAAmB;QAAnB,4DAAmB;QAAnB;AAAmB;AAAnB;QAAA,oCAAmB;QAAnB,2DAAmB;QAAnB;AAAmB;AAAnB;QAAA,uCAAmB;QAAnB,8DAAmB;QAAnB;AAAmB;AAAnB;QAAA,+EAAmB;QAAnB,mGAAmB;QAAnB;AAAmB;AAAnB;QAAA,6EAAmB;QAAnB,iGAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,2GAAmB;QAAnB,yGAAmB;QAAnB;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,oBAAmB;QAAnB;AAAmB;AAAnB;QAAA;AAAmB;AAAnB;QAAA,sCAAmB;QAAnB,0RAAmB;gBAAnB;AAAmB;AAAnB;QAAA,6BAAmB;QAAnB,+QAAmB;gBAAnB;AAAmB;AAAnB;QAAA,gKAAmB;QAAnB,wJAAmB;QAAnB,iLAAmB;QAAnB,wDAAmB;QAAnB;AAAmB;AAAnB;QAAA,wBAAmB;QAAnB,wDAAmB;QAAnB;AAAmB;IAKf;QACI,wBAAwB,GAAG,0BAA0B;QACrD,qBAAqB,GAAG,YAAY;IACxC;IACA;QACI,aAAa,GAAG,sBAAsB;IAC1C;;IAGI;QAAA;AAAa;;IAIb;QAAA,oBAA2B;QAA3B;AAA2B;;IAC3B;QAAA;gBAAA;QAA8B;AAAA;;IAA9B;QAAA;gBAAA;QAA8B;AAAA;;IAI9B;QAAA,YAAyD;QAAzD,mBAAyD;QAAzD,gBAAyD;QAAzD;AAAyD;;IAAzD;QAAA;gBAAA;QAAyD;AAAA;;IACzD;QAAA;gBAAA,oBAAuD;gBAAvD;QAAuD;AAAA;;IACvD;QAAA;gBAAA;QAAyB;AAAA;IAGzB;QAAA,iBAAuC;QAAvC,kBAAuC;QAAvC;AAAuC;IAAvC;QAAA;gBAAA,iBAAuC;gBAAvC;QAAuC;AAAA;IACvC;QAAA,UAAuC;QAAvC,iBAAuC;QAAvC;AAAuC;IAAvC;QAAA;gBAAA;QAAuC;AAAA;IAGvC;QAAA,UAA6D;QAA7D,mBAA6D;QAA7D,kBAA6D;QAA7D,yDAA6D;QAA7D;AAA6D;IAA7D;QAAA;gBAAA;QAA6D;AAAA;IAC7D;QAAA;gBAAA,WAAqD;gBAArD;QAAqD;AAAA;IAArD;QAAA;gBAAA,kBAAqD;gBAArD;QAAqD;AAAA;;IAIrD;QAAA,UAAyC;QAAzC;AAAyC;;IAAzC;QAAA;gBAAA;QAAyC;AAAA;;IACzC;QAAA;gBAAA,WAAqC;gBAArC,iBAAqC;gBAArC;QAAqC;AAAA;;IACrC;QAAA;gBAAA,iBAAiC;gBAAjC;QAAiC;AAAA;;IAIjC;QAAA,0BAAuB;QAAvB;AAAuB;;IAIvB;QAAA,mBAA0E;QAA1E,0BAA0E;QAA1E,wBAA0E;QAA1E,kBAA0E;QAA1E,gBAA0E;QAA1E,oBAA0E;QAA1E;AAA0E;IAG1E;QAAA,kBAAyC;QAAzC,+BAAyC;QAAzC;AAAyC;IAGzC;QAAA,oBAA2B;QAA3B;AAA2B;;IAI3B;QAAA,aAAmC;QAAnC,eAAmC;QAAnC;AAAmC;;IACnC;QAAA;gBAAA;QAAmB;AAAA;;IAInB;QAAA;AAAW;;IACX;QAAA;gBAAA,WAAgE;gBAAhE,aAAgE;gBAAhE,uBAAgE;gBAAhE;QAAgE;AAAA;;IAIhE;QAAA,0BAA8C;QAA9C,iBAA8C;QAA9C;AAA8C;;IAI9C;QAAA;AAAqC;;IAArC;QAAA;gBAAA;QAAqC;AAAA;;IAIrC;QAAA,YAAoE;QAApE,8BAAoE;QAApE,uBAAoE;QAApE,mBAAoE;QAApE;AAAoE;;IAApE;QAAA;gBAAA,mBAAoE;gBAApE,sBAAoE;gBACpE,YAA8D;gBAA9D,gBAA8D;gBAA9D;QADoE;AAAA;;IAKpE;QAAA,WAAmC;QAAnC;AAAmC;;IAAnC;QAAA;gBAAA;QAAmC;AAAA;;IAGvC;QACI,0DAA4D;QAC5D,kBAA+D;QAA/D,WAA+D;QAA/D,wBAA+D;QAA/D,2BAA+D;QAA/D,4BAA+D;QAA/D,oBAA+D;IACnE;;IAEA;QACI,0DAA0D;QAC1D,kBAA+D;QAA/D,WAA+D;QAA/D,wBAA+D;QAA/D,2BAA+D;QAA/D,4BAA+D;QAA/D,oBAA+D;IAGnE;;IAFI;QAAA;gBAAA,iBAAuE;gBAAvE,kBAAuE;gBAAvE,aAAuE;gBAAvE,YAAuE;QAAvE;QAAuE;AAAA;;IACvE;QAAA;gBAAA,aAAwC;gBAAxC;QAAwC;AAAA;;IAOxC;QAAA;;;;gBAAA,kBAAmG;gBAAnG,WAAmG;gBAAnG,mBAAmG;gBAAnG,aAAmG;gBAAnG,YAAmG;gBAAnG;QAAmG;AAAA;;IACnG;QAAA;;;;gBAAA;QAAwB;AAAA;;IAMxB;QAAA;;;gBAAA;QAAmB;AAAA;;IAInB;QAAA,oBAAuB;QAAvB;AAAuB;;IACvB;QAAA;gBAAA,WAA+D;gBAA/D,eAA+D;gBAA/D,mBAA+D;gBAA/D,sBAA+D;gBAA/D;QAA+D;AAAA;;IAC/D;QAAA;gBAAA,iBAAkB;gBAAlB;QAAkB;AAAA;;IAIlB;QAAA;AAAa;;IAIb;QAAA;AAAa;;IACb;QAAA;gBAAA,eAAmF;gBAAnF,WAAmF;gBAAnF,WAAmF;gBAAnF,cAAmF;gBAAnF;QAAmF;AAAA;;IACnF;QAAA;gBAAA,iBAAyC;gBAAzC;QAAyC;AAAA;;IAG7C,YAAY;IAER;QAAA;gBAAA,WAAmD;gBAAnD,eAAmD;gBAAnD,mBAAmD;gBAAnD;QAAmD;AAAA;IACnD;QAAA;gBAAA,iBAAkB;gBAAlB;QAAkB;AAAA;;IAIlB;QAAA;gBAAA;QAAwB;AAAA;;IACxB;QAAA;gBAAA;QAAwB;AAAA;;IAIxB;QAAA,mBAAmE;QAAnE,eAAmE;QAAnE,gBAAmE;QAAnE,iBAAmE;QAAnE,oBAAmE;QAAnE,6CAAmE;QACnE,aAAsC;QAAtC,mBAAsC;QAAtC;AADmE;;IAEnE;QAAA;gBAAA;QAAoB;AAAA;;IAIpB;QAAA,eAAiE;QAAjE,gBAAiE;QAAjE,yBAAiE;QAAjE,oBAAiE;QAAjE,oBAAiE;QAAjE;AAAiE;;IACjE;QAAA;gBAAA,kBAA+B;gBAA/B,kBAA+B;gBAA/B;QAA+B;AAAA;;IAC/B;QAAA;gBAAA,kBAAkB;gBAAlB;QAAkB;AAAA;;IAIlB;QAAA;gBAAA,wBAA2E;gBAA3E,mBAA2E;gBAA3E,sBAA2E;gBAA3E;QAA2E;AAAA;;IAI3E;QAAA;AAAa;;IAIb;QAAA;AAAY;;IACZ;QAAA;gBAAA,kBAAmD;gBAAnD,6BAAmD;gBAAnD;QAAmD;QAInD;gBAAA,gBAAkB;gBAAlB;QAAkB;QAIlB;gBAAA,kBAAkB;gBAClB,qBAAgE;gBAAhE,kBAAgE;gBAAhE;QADkB;;IAClB;gBAAA;wBAAA,wBAAgE;wBAAhE,mBAAgE;wBAAhE,sBAAgE;wBAAhE;gBAAgE;QAAA;AATb;;IAUnD;QAAA;gBAAA,kBAAkB;gBAAlB;QAAkB;AAAA;;IAIlB;QAAA,qBAAiB;QAAjB,sBAAiB;QAAjB;AAAiB;;IACjB;QAAA;gBAAA,qBAA4E;gBAA5E,kBAA4E;gBAA5E,mBAA4E;gBAA5E;QAA4E;;IAA5E;gBAAA;wBAAA,wBAA4E;wBAA5E,mBAA4E;wBAA5E,sBAA4E;wBAA5E;gBAA4E;QAAA;AAAA;;IAC5E;QAAA;gBAAA,kBAAkB;gBAAlB;QAAkB;AAAA;;IAIlB;QAAA,gBAA4B;QAA5B,aAA4B;QAA5B;AAA4B;;IAC5B;QAAA;gBAAA,mBAAkE;gBAAlE,eAAkE;gBAAlE,kBAAkE;gBAAlE,mBAAkE;gBAAlE;QAAkE;AAAA;;IAClE;QAAA;gBAAA,kBAAkB;gBAAlB;QAAkB;AAAA;;IAIlB;QAAA,eAAyF;QAAzF,SAAyF;QAAzF,UAAyF;QAAzF,WAAyF;QAAzF,aAAyF;QAAzF,4BAAyF;QAAzF,6BAAyF;QAAzF,kBAAyF;QAAzF,yDAAyF;QAAzF,mBAAyF;QAAzF;AAAyF;;IACzF;QAAA;gBAAA;QAAmB;AAAA;;IAInB;QAAA,qBAA2C;QAA3C,aAA2C;QAA3C,mBAA2C;QAA3C;AAA2C;;IAI3C;QAAA,kBAAuE;QAAvE,mBAAuE;QAAvE,eAAuE;QAAvE,gBAAuE;QAAvE,iBAAuE;QAAvE,oBAAuE;QAAvE;AAAuE;;IACvE;QAAA;gBAAA,kBAAkB;gBAAlB;QAAkB;AAAA;;IAIlB;QAAA,kBAAwB;QAAxB;AAAwB;;IAAxB;QAAA;gBAAA,kBAAwB;gBAAxB;QAAwB;AAAA;;IAIxB;QAAA,kBAAqE;QAArE,kBAAqE;QAArE,mBAAqE;QAArE,eAAqE;QAArE,gBAAqE;QAArE,oBAAqE;QAArE;AAAqE;;IAArE;QAAA;gBAAA,kBAAqE;gBAArE;QAAqE;AAAA;;IAIrE;QAAA,eAA8C;QAA9C,gBAA8C;QAA9C;AAA8C;;IAI9C;QAAA;AAAW;;IAIX;QAAA;AAAW;;IAAX;QAAA;AAAW;;IAIX;QAAA;AAAuB;;IAAvB;QAAA;gBAAA;QAAuB;AAAA;;IAAvB;QAAA;AAAuB;;IAAvB;QAAA;gBAAA;QAAuB;AAAA;;IAIvB;QAAA,aAAwB;QAAxB;AAAwB;;IAAxB;QAAA,aAAwB;QAAxB;AAAwB;;IAIxB;QAAA,kBAAgB;QAAhB;AAAgB;;IAlOxB;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA,0BAoOC;QApOD;AAoOC;;IApOD;QAAA,0BAoOC;QApOD;AAoOC;;IApOD;QAAA,0BAoOC;QApOD;AAoOC;;IApOD;QAAA,0BAoOC;QApOD;AAoOC;;IApOD;QAAA,0BAoOC;QApOD;AAoOC;;IApOD;QAAA,0BAoOC;QApOD;AAoOC;;IApOD;QAAA,0BAoOC;QApOD,kBAoOC;QApOD;AAoOC;;IApOD;QAAA,0BAoOC;QApOD;AAoOC;;IApOD;QAAA,0BAoOC;QApOD;AAoOC;;IApOD;QAAA,0BAoOC;QApOD;AAoOC;;IApOD;QAAA,0BAoOC;QApOD;AAoOC;;IApOD;QAAA,0BAoOC;QApOD;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA,oBAoOC;QApOD;AAoOC;;IApOD;QAAA,0BAoOC;QApOD,0BAoOC;QApOD;AAoOC;;IApOD;QAAA,6BAoOC;QApOD,6BAoOC;QApOD;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA,kBAoOC;QApOD;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA,kBAoOC;QApOD;AAoOC;;IApOD;QAAA,oBAoOC;QApOD;AAoOC;;IApOD;QAAA,oBAoOC;QApOD;AAoOC;;IAlLO;QAAA,kBAAyC;QAAzC,+BAAyC;QAAzC;AAAyC;;IAGzC;QAAA,oBAA2B;QAA3B;AAA2B;;IArDnC;QAAA;AAoOC;;IApOD;QAAA,kBAoOC;QApOD;AAoOC;;IApOD;QAAA;gBAAA;QAoOC;QApOD;gBAAA,gCAoOC;gBApOD;QAoOC;AAAA;;IApOD;QAAA;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA,iBAoOC;gBApOD;QAoOC;QApOD;gBAAA,gBAoOC;gBApOD;QAoOC;QApOD;gBAAA,gBAoOC;gBApOD;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA,wBAoOC;gBApOD;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA,sBAoOC;gBApOD;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA,6BAoOC;gBApOD;QAoOC;QApOD;gBAAA,kBAoOC;gBApOD;QAoOC;QApOD;gBAAA,qBAoOC;gBApOD;QAoOC;QApOD;gBAAA,mBAoOC;gBApOD;QAoOC;QApOD;gBAAA,iBAoOC;gBApOD;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA,oBAoOC;gBApOD;QAoOC;;IAdO;gBAAA;QAAW;;IAAX;gBAAA;QAAW;;IAAX;gBAAA;QAAW;;IAIX;gBAAA;QAAuB;;IAAvB;gBAAA;wBAAA;gBAAuB;QAAA;;IAJvB;gBAAA;QAAW;;IAIX;gBAAA;QAAuB;;IAAvB;gBAAA;wBAAA;gBAAuB;QAAA;;IAJvB;gBAAA;QAAW;;IAIX;gBAAA;QAAuB;;IAAvB;gBAAA;wBAAA;gBAAuB;QAAA;;IAIvB;gBAAA,aAAwB;gBAAxB;QAAwB;;IARxB;gBAAA;QAAW;;IAIX;gBAAA;QAAuB;;IAAvB;gBAAA;wBAAA;gBAAuB;QAAA;;IAIvB;gBAAA,aAAwB;gBAAxB;QAAwB;;IA9NhC;gBAAA,0BAoOC;gBApOD;QAoOC;;IApOD;gBAAA,6BAoOC;gBApOD,6BAoOC;gBApOD;QAoOC;AAAA;;IApOD;QAAA;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA,iBAoOC;gBApOD;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA,sBAoOC;gBApOD;QAoOC;QApOD;gBAAA,sBAoOC;gBApOD;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA,kBAoOC;gBApOD;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA,4BAoOC;gBApOD;QAoOC;QApOD;gBAAA,+BAoOC;gBApOD;QAoOC;QApOD;gBAAA,kBAoOC;gBApOD;QAoOC;QApOD;gBAAA,kBAoOC;gBApOD;QAoOC;QApOD;gBAAA,oBAoOC;gBApOD;QAoOC;QApOD;gBAAA,mBAoOC;gBApOD;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA,oBAoOC;gBApOD;QAoOC;;IAdO;gBAAA;QAAW;;IAAX;gBAAA;QAAW;;IAAX;gBAAA;QAAW;;IAIX;gBAAA;QAAuB;;IAAvB;gBAAA;wBAAA;gBAAuB;QAAA;;IAJvB;gBAAA;QAAW;;IAIX;gBAAA;QAAuB;;IAAvB;gBAAA;wBAAA;gBAAuB;QAAA;;IA1N/B;gBAAA;QAoOC;;IAVO;gBAAA;QAAuB;;IAAvB;gBAAA;wBAAA;gBAAuB;QAAA;;IAJvB;gBAAA;QAAW;;IAIX;gBAAA;QAAuB;;IAAvB;gBAAA;wBAAA;gBAAuB;QAAA;;IAIvB;gBAAA,aAAwB;gBAAxB;QAAwB;;IARxB;gBAAA;QAAW;;IAIX;gBAAA;QAAuB;;IAAvB;gBAAA;wBAAA;gBAAuB;QAAA;;IAIvB;gBAAA,aAAwB;gBAAxB;QAAwB;;IA9NhC;gBAAA,0BAoOC;gBApOD;QAoOC;AAAA;;IApOD;QAAA;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA,gBAoOC;gBApOD;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA,kBAoOC;gBApOD;QAoOC;QApOD;gBAAA,kBAoOC;gBApOD;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA,oCAoOC;gBApOD,2DAoOC;gBApOD;QAoOC;;IAdO;gBAAA;QAAW;;IAIX;gBAAA;QAAuB;;IAAvB;gBAAA;wBAAA;gBAAuB;QAAA;;IAJvB;gBAAA;QAAW;;IAIX;gBAAA;QAAuB;;IAAvB;gBAAA;wBAAA;gBAAuB;QAAA;;IAIvB;gBAAA,aAAwB;gBAAxB;QAAwB;AAM/B;;IApOD;QAAA;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;AAAA;;IApOD;QAAA;gBAAA;QAoOC;AAAA;;IApOD;QAAA;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;AAAA;;IApOD;QAAA;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA,oBAoOC;gBApOD;QAoOC;QApOD;gBAAA,kBAoOC;gBApOD;QAoOC;QApOD;gBAAA,kBAoOC;gBApOD;QAoOC;QApOD;gBAAA,oBAoOC;gBApOD;QAoOC;QApOD;gBAAA,iBAoOC;gBApOD;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA,oBAoOC;gBApOD;QAoOC;QApOD;gBAAA;wBAAA;gBAoOC;gBApOD;wBAAA;gBAoOC;QAAA;AAAA;;IApOD;QAAA;gBAAA;wBAAA;gBAoOC;gBApOD;wBAAA;gBAoOC;QAAA;AAAA;;IApOD;QAAA;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA,mBAoOC;gBApOD;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA,kBAoOC;gBApOD;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA,qBAoOC;gBApOD;QAoOC;QApOD;gBAAA,mBAoOC;gBApOD;QAoOC;QApOD;gBAAA,iBAoOC;gBApOD;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA;QAoOC;QApOD;gBAAA,oBAoOC;gBApOD;QAoOC;AAAA;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA,gBAoOC;QApOD,uBAoOC;QApOD;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA,mBAoOC;QApOD;AAoOC;;IApOD;QAAA,kBAoOC;QApOD;AAoOC;;IApOD;QAAA,mBAoOC;QApOD;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA,kBAoOC;QApOD;AAoOC;;IApOD;QAAA,oBAoOC;QApOD;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA,oBAoOC;QApOD;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA,oBAoOC;QApOD;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC;;IApOD;QAAA;AAoOC","sourcesContent":["@tailwind utilities;\n@layer utilities {\n    .pb-unset {\n        padding-bottom: unset;\n    }\n    .no-scroll {\n        -ms-overflow-style: none;  /* Internet Explorer 10+ */\n        scrollbar-width: none;  /* Firefox */\n    }\n    .no-scroll::-webkit-scrollbar {\n        display: none;  /* Safari and Chrome */\n    }\n\n    .mock-exam-layout .cb-focus input {\n        @apply hidden;\n    }\n\n    .mock-exam-layout .tablet-illustration {\n        @apply -mb-[10px] mt-[10px];\n        @apply max-sm:hidden lg:hidden;\n    }\n\n    .mock-exam-layout .phone-illustration {\n        @apply sm:hidden -mb-[9px] max-w-[336px] m-auto mt-[20px];\n        @apply max-[400px]:max-w-[240px] max-[400px]:-mb-[19px];\n        @apply max-[300px]:hidden;\n    }\n    .mock-exam-layout .progress-container {\n        @apply w-[90%] max-lg:py-[20px] mx-auto;\n        @apply py-[20px] w-3/5 lg:min-w-[343px];\n    }\n    .mock-exam-layout .container-form {\n        @apply bg-white p-[40px] w-[91%] rounded-2xl lg:min-w-[343px];\n        @apply max-lg:w-full max-lg:p-[40px] max-sm:px-[24px];\n    }\n\n    .mock-exam-layout .container-selector {\n        @apply text-left w-[90%] lg:min-w-[343px];\n        @apply max-lg:w-full max-lg:py-[40px];\n        @apply lg:mt-[-70px] lg:ml-[30px];\n    }\n\n    .mock-exam-layout .link-text a {\n        @apply !inline !text-sm;\n    }\n\n    .mock-exam-layout .forgot-back {\n        @apply !flex !inline text-left text-primary-apricot fill-current mb-[17px];\n    }\n    .mock-exam-layout .forgot-back-hover svg {\n        @apply !text-primary-skyblue fill-current;\n    }\n    .mock-exam-layout .forgot-back-hover a {\n        @apply text-primary-skyblue;\n    }\n\n    .mock-exam-layout a.back-mobile {\n        @apply text-[16px] font-bold hidden;\n        @apply max-lg:block;\n    }\n\n    .mock-exam-layout .header-container {\n        @apply h-16;\n        @apply max-lg:flex max-lg:pl-0 max-lg:justify-center max-lg:z-20;\n    }\n\n    .mock-exam-layout .body-container {\n        @apply pt-16 min-h-screen h-[calc(100vh-64px)];\n    }\n\n    .mock-exam-layout .animation-container {\n        @apply min-h-full max-lg:min-h-[auto];\n    }\n\n    .mock-exam-layout .form-container {\n        @apply items-start py-10 h-full min-h-[calc(100vh-64px)] max-lg:py-6;\n        @apply max-lg:min-h-[auto] max-lg:items-center max-lg:h-[auto];\n    }\n\n    .mock-exam-layout .mock-exam-left-container, .mock-exam-layout .webinar-left-container {\n        @apply w-full pr-[54px] max-lg:pr-0;\n    }\n\n    .mock-exam-layout .mock-exam-left-content {\n        background-image: url('@assets/images/mock_exam_poster.svg');\n        @apply w-full pb-[100%] mt-10 bg-contain bg-center bg-no-repeat;\n    }\n\n    .mock-exam-layout .webinar-left-content {\n        background-image: url('@assets/images/webinar_poster.svg');\n        @apply w-full pb-[100%] mt-10 bg-contain bg-center bg-no-repeat;\n        @apply max-lg:w-[546px] max-lg:h-[523px] max-lg:mx-auto max-lg:pb-unset;\n        @apply max-sm:w-[323px] max-sm:h-[334px];\n    }\n\n    .mock-exam-layout.mock-exam-get-started .animation-container,\n    .mock-exam-layout.webinar-payment .animation-container,\n    .mock-exam-layout.webinar-welcome .animation-container,\n    .mock-exam-layout.webinar-payment .form-container {\n        @apply max-lg:flex max-lg:ml-[-110px] max-lg:w-screen max-lg:z-10 max-lg:relative max-lg:max-w-none;\n        @apply max-sm:ml-[-15px];\n    }\n\n    .mock-exam-layout.mock-exam-get-started .body-container,\n    .mock-exam-layout.webinar-welcome .body-container,\n    .mock-exam-layout.webinar-payment .body-container {\n        @apply max-lg:block;\n    }\n\n    .mock-exam-layout.mock-exam-get-started .form-container {\n        @apply pl-10 pt-[110px];\n        @apply max-lg:py-14 max-lg:w-full max-lg:max-w-none max-lg:pl-0;\n        @apply max-sm:py-4;\n    }\n\n    .mock-exam-layout .auth-layout-background {\n        @apply hidden;\n    }\n\n    .mock-exam-background {\n        @apply hidden;\n        @apply max-lg:block max-lg:fixed max-lg:bottom-0 max-lg:max-w-[580px] max-lg:z-[-1];\n        @apply max-sm:w-11/12 max-sm:max-w-[485px]\n    }\n\n    /* Webinar */\n    .mock-exam-layout.webinar-welcome .form-container {\n        @apply max-lg:py-14 max-lg:w-full max-lg:max-w-none;\n        @apply max-sm:py-4;\n    }\n\n    .mock-exam-layout.webinar-welcome .container-form {\n        @apply max-lg:mt-[-37px];\n        @apply max-sm:mt-[-22px];\n    }\n\n    .webinar-payment-title {\n        @apply font-black text-primary-navyblue text-xl leading-[32px] mb-4;\n        @apply flex justify-start items-center;\n        @apply max-lg:hidden;\n    }\n\n    .webinar-payment-label {\n        @apply text-sm font-black text-neutral-eraser uppercase leading-5;\n        @apply max-lg:px-16 max-lg:mt-6;\n        @apply max-sm:px-4;\n    }\n\n    .webinar-payment-separator {\n        @apply max-lg:border-b-8 max-lg:border-solid max-lg:border-neutral-notebook;\n    }\n\n    .mock-exam-layout.mock-exam-layout.webinar-payment .auth-layout-background {\n        @apply hidden;\n    }\n\n    .mock-exam-layout.webinar-payment .container-form {\n        @apply mb-10;\n        @apply max-lg:bg-transparent max-lg:p-0 max-lg:mb-0;\n    }\n\n    .mock-exam-layout.webinar-payment .form-container {\n        @apply max-lg:py-0;\n    }\n\n    .webinar-address-container {\n        @apply max-lg:mt-6;\n        @apply max-lg:webinar-payment-separator max-lg:mb-6 max-lg:px-16;\n        @apply max-sm:px-4;\n    }\n\n    .mock-exam-layout.webinar-payment .webinar-payment-frame-container {\n        @apply mt-4 -mx-3;\n        @apply max-lg:webinar-payment-separator max-lg:mb-6 max-lg:px-16 max-lg:pb-6;\n        @apply max-sm:px-4;\n    }\n\n    .webinar-payment-checkbox-container {\n        @apply flex items-start mt-8;\n        @apply max-lg:px-16 max-lg:mb-[10px] max-lg:mt-0 max-lg:pb-[371px];\n        @apply max-sm:px-4;\n    }\n\n    .webinar-payment-floating-footer {\n        @apply hidden fixed left-0 right-0 bottom-0 bg-neutral-chalk rounded-t-2xl pt-6 pb-[27px];\n        @apply max-lg:block;\n    }\n\n    .webinar-payment-detail {\n        @apply flex justify-start items-center mb-6;\n    }\n\n    .webinar-payment-floating-footer .webinar-payment-detail p {\n        @apply font-bold text-[24px] text-primary-navyblue px-16 leading-[35px];\n        @apply max-sm:px-4;\n    }\n\n    .webinar-payment-floating-footer button {\n        @apply px-16 max-sm:px-4;\n    }\n\n    .webinar-payment-floating-footer > p {\n        @apply mt-6 font-medium text-xs text-neutral-pencil px-16 max-sm:px-4;\n    }\n\n    .mock-exam-layout.webinar-payment {\n        @apply fixed overflow-y-auto overflow-x-hidden;\n    }\n\n    .webinar-snackbar .message-button {\n        @apply ml-0;\n    }\n\n    .webinar-snackbar > div > .max-w-full {\n        @apply flex;\n    }\n\n    .webinar-snackbar > div > .max-w-full > .float-left {\n        @apply pr-8 max-sm:pr-4;\n    }\n\n    .webinar-snackbar .icon-container, .webinar-snackbar > div > .max-w-full > .float-right {\n        @apply flex items-center;\n    }\n\n    .payment-failed-popup div.popup-container {\n        @apply px-[34px];\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
